import { IStoreMenuCategory, IStoreMenuCategoryItem, StoreService, IStore, IStoreMenu, IHours, IStoreMenuItem, ITranslatableText, IMenuItem, OrderTypeEnum, EOpenHoursDay, IMeasurements, IStoreMenuItemOption, IOpenHour } from './store.service';
import { OrderType } from '../pages/list-page/list-page.component';
import { Injectable } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { ItemOptionComponent } from '../components/item-option/item-option.component';
import { ItemRequestComponent } from '../components/item-request/item-request.component';
import { LoaderService } from 'src/app/shared/services/loader.service';
//import * as moment from 'moment';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, first, tap } from 'rxjs/operators';
import { CartModalComponent } from '../modals/cart/cart-modal.component';
import { CheckoutModalComponent } from '../modals/checkout-modal/checkout-modal.component';
import { ICustomerTransactionEmail, ReceiptComponent } from '../components/receipt/receipt.component';
import { ImageService } from 'src/app/shared/services/image.service';
import { MenuItemDetailModalComponent } from 'src/app/shared/modals/menu-item-detail-modal/menu-item-detail-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
//import * as momentTimeZone from 'moment-timezone';
import momentTimeZone from 'moment-timezone';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ProceedAsGuestModalComponent } from 'src/app/auth/modals/proceed-as-guest-modal/proceed-as-guest-modal.component';
import { MENU_CATEGORY_THEME, SettingService } from 'src/app/shared/services/setting.service';
import * as _ from 'lodash';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AlertController } from '@ionic/angular';
import { IAddress } from 'src/app/shared/services/address.service';
import { ItemBrandServiceService } from './item-brand-service.service';
import { Storage } from '@ionic/storage';
import { ItemService } from './item.service';
//import { nextTick } from 'process';
//import { request } from 'http';
import { ClosedModalComponent } from '../modals/closed/closed-modal.component';
//import { removeSummaryDuplicates } from '@angular/compiler';
import { OrderListPageComponent } from 'src/app/account/pages/order-list-page/order-list-page.component';
//import { resolveSanitizationFn } from '@angular/compiler/src/render3/view/template';
import { MenuItemOptionDetailModalComponent } from 'src/app/shared/modals/menu-item-option-detail-modal/menu-item-option-detail-modal.component';
import { TableOrderConfirmationModalComponent } from '../modals/table-order-confirmation/table-order-confirmation-modal.component';
import { IPlacePreOrderBase } from './preorder.service';
import { DesktopCheckout } from '../components/desktop-checkout/desktop-checkout.component';
import { ItemTwoForOnesComponent } from '../components/item-two-for-ones/item-two-for-ones.component';
//import { StoreListModalComponent } from 'src/app/store/modals/store-list-modal/store-list-modal.component';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { IAvailableHour, IItemDetailCombination, IOrder, IOrderItem, IOrderItemOption } from './order.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { MenuItemAllinoneModalComponent } from 'src/app/shared/modals/menu-item-allinone-modal/menu-item-allinone-modal.component';
import { StoreListModalComponent } from 'src/app/store/modals/store-list-modal/store-list-modal.component';
import { ItemPreparationModalComponent } from '../modals/item-preparation/item-preparation-modal.component';

const CACHE_KEY='cartStorage';
interface itemDetailCombination{
  size: ITranslatableText,
  color: ITranslatableText,
  code: string,
  colorId: string,
  id: string,
  isDeleted: false,
  price: number,
  sizeId: string,
  measurementsId: string,
  measurements: IMeasurements
}

interface IDepartment{
  id: string,
  name: ITranslatableText 
}

interface IItemCategories{
  id: string;
  name: ITranslatableText
}

export interface itemColors {
  name: ITranslatableText,
   id: string,
   itemId: string,
   merchantId: string
 }

export interface itemSize {
  name: ITranslatableText,
  id: string,

  itemId: string,
  merchantId: string,

  abbreviation?: any;
}


  

@Injectable({
  providedIn: 'root'
})


export class MenuService {
  twoForOneCats: IStoreMenuCategory[] = []
  twoForOneSelectedItem: IStoreMenuItem = null;
  twoForOneSelectedCategory: IStoreMenuCategory = null;
  itemCategories: IItemCategories[]=[];
  itemSubCategories: any[]=[];
  itemColors: itemColors[]=[];
  itemSize: itemSize[]=[];
  combinationPrice: number=null;
  currentItem: IOrderItem;
  //retailQuantity: number=1;
  retailQuantity: number;
  filteredItem: any;
  uniqueItem: IStoreMenuItem[]=[];
  order: IOrder = {
    store: null,
    orderItems: [],
    note: "",
    _deliveryType: "delivery" //used for checkout and other pages
  }; 
  orderType: OrderType; // used to add to cart
  isStoreRetail: boolean=false;
  store: IStore;
  itemDetailCombination: itemDetailCombination;
  //quantity=0;
  menu: IStoreMenu;
  trackStoreId: string;
  itemAvailableHour: IAvailableHour[];
  storeClosed: boolean = false;
  useMenuWithImages: boolean = true;
  showTimeSelector: boolean = true;
  private cssClass: string = '';
  //storeName: string;
  followingDays:any[] = [];
  followingTime:any[] = [];
  prepareFollowingDays:any[] = [];
  prepareFollowingTime:any[] = [];
  sortedMenu: IStoreMenuItem[]=[];
  menuDayPlaceholder: string;
  menuTimePlaceholder: string;
  sameDay :boolean=false;
  prepareSameDay: boolean = false;
  dateAutoChanged = false;
  menuDepartments: IDepartment[]=[];
  isLightTheme: boolean = false;
  itemBrands: any[]=[]
  menuList  : IStoreMenu[];
  hideTableOrderCheckout: boolean = false;

  buynow: boolean = false;

  // for the preloader
  LastStoreMenuCollected: string[] = [];

  get getorder() {
    var cleanedOrderItems = [];
    for(var i = 0; i < this.order.orderItems.length; i++) {
      if(this.order.orderItems[i] != null) {
        cleanedOrderItems.push(this.order.orderItems[i]);
      }
    }
    this.order.orderItems = cleanedOrderItems;
    return this.order;
  }

  // to refresh menu page
  private refreshMenuSubject = new Subject<void>();
  refreshMenu$ = this.refreshMenuSubject.asObservable();


    constructor(private modalController: ModalController,
      private itemService: ItemService,
      public itemBrandService: ItemBrandServiceService,
      private alertCtrl: AlertController,
      private loaderService: LoaderService,
      //private http: HttpClient,
      private storeService: StoreService,
      private router: Router,
      //private translateService: TranslateService,
      private imageService: ImageService,
      private sanitization: DomSanitizer,
      private authService: AuthService,
      private settingService: SettingService,
      private storage: Storage,
      public route: ActivatedRoute,
      private navCtrl: NavController,
      private analytics: AnalyticsService,
      private http: HttpClient,
      private translationService: TranslationService) {
        this.menuDayPlaceholder = this.translationService.translate('Menu.Placeholder.Day');
        this.menuTimePlaceholder = this.translationService.translate('Menu.Placeholder.Time');
      }
    
    validateAvailability(category: IStoreMenuCategory, deliveryType: OrderType) {
        //Validating if the order is available for takeout/delivery
        if ((deliveryType == "delivery" && !category.isDelivery) ||
          (deliveryType == "pickup" && !category.isTakeOut) ||
          (deliveryType == "table" && !category.isTableOrder)) {
          return false;
        }
    
        return true;
    }

    toggleCategory(menuCategorie: IStoreMenuCategory) {
        if (!menuCategorie._open)
          menuCategorie._open = true;
        else
          menuCategorie._open = false;
    }

    validDeliveryMode(item: IStoreMenuCategoryItem, deliveryType: OrderType) {
      /*
        if ((deliveryType == "pickup" && !item.item.isTakeOut) ||
        (deliveryType == "delivery" && !item.item.isDelivery) ||
        (deliveryType == "shipping" && !item.item.isShipping) ||
        (deliveryType == "shipping" && !item.item.isRetailItem) ) {
          return false;
        }
      */  
        if ((deliveryType == "pickup" && !item.item.isTakeOut) ||
        (deliveryType == "delivery" && !item.item.isDelivery) ||
        (deliveryType == "shipping" && !item.item.isShipping) ) {
          return false;
        }
    
        return true;
    }

    notAvailable(header,message)
    {
     this.alertCtrl.create({
       header: header,
       message: message,
       buttons: [
         {
           text: 'Ok',
           role: 'cancel',
           cssClass: 'secondary',
           handler: () => {
             
           }
         }
       ]
     }).then(al => {
       al.present();
     });
    }
    //An important logically point to consider as we are passing item also we are passing sub item and both of them have different types 
    //but before we gave both the same type which was not correct. So thats why changed it to any.
    //item: IStoreMenuCategoryItem | IStoreMenuItem wasnt working so ll ask how to give either or type to a variable. For now it ll work with any
    async itemDetail(item: any, chosenItemDetailCombination?: IItemDetailCombination, chosenQuantity?: number, itemCategory?: any) {
      // this is when an item has been selected but not added (just looking at the details)
      //console.log(this.order);
      console.log(item);
      console.log(itemCategory);

      this.analytics.sendItemUpdate(true, item, null, this.order, true, null, null, "viewItem");

      //Need to check this blog
	    //Table orders: allow user to look at menu but unable to add items to cart
      if(this.hideTableOrderCheckout){
        return;
      }

      //check if available now or another date/time required
      if(item.item?.itemPreparation && item.item?.itemPreparation.isActive){
        const numberOfDaysToInclude = 30;
        this.prepareFollowingDays = [];

        const now = moment();
        const prepTime = item.item.itemPreparation.prepareTime ?? 0;
        const prepDays = item.item.itemPreparation.prepareDays ?? 0;

        for (let i = 0; i < numberOfDaysToInclude; i++) {
          const currentDate = now.clone()
            .locale(this.translationService.getLanguage())
            .add(i, "days");

          const newDateKey = currentDate.format("YYYY-MM-DD");
          const newDateLabel = currentDate.format("Do MMMM");

          // skip calendar days
          if (prepDays > 0 && i <= prepDays) {
            continue;
          }

          const dayBit = currentDate.day() === 0
            ? 64
            : 1 << (currentDate.day() - 1);

          // Item preparation weekday restriction
          if (item.item.itemPreparation.weekDays != 0) {
            if ((item.item.itemPreparation.weekDays & dayBit) === 0) {
              continue;
            }
          }

          // Skip today if store is already considered closed
          if (this.store != null) {
            if (i === 0 && this.store._closedAfterClosedHours) {
              continue;
            }
          }

          // Find store opening hours for this day
          let openHourVal: IOpenHour = null;

          if (this.store?.openHours && Array.isArray(this.store.openHours)) {
            for (const oh of this.store.openHours) {
              if ((oh.days & dayBit) !== 0) {
                openHourVal = oh;
                break;
              }
            }
          }

          // Store is closed on this day
          if (!openHourVal) {
            continue;
          }

          const openTime = moment(
            `${newDateKey} ${openHourVal.openHours}`,
            "YYYY-MM-DD h:mma"
          );

          const closeTime = moment(
            `${newDateKey} ${openHourVal.closeHours}`,
            "YYYY-MM-DD h:mma"
          );

          // check if needs to go next day opening hours
          if (!closeTime.isAfter(openTime)) {
            closeTime.add(1, "day");
          }

          let adjustedOpenHour: IOpenHour = {
            ...openHourVal
          };

          let earliestAvailableTime: moment.Moment;

          if (prepDays === 0 && i === 0) {
            const preparationStartTime = moment.max(
              now.clone(),
              openTime.clone()
            );

            earliestAvailableTime = preparationStartTime
              .clone()
              .add(prepTime, "hours");
          }
          else {
            earliestAvailableTime = openTime
              .clone()
              .add(prepTime, "hours");
          }

          if (earliestAvailableTime.isSameOrAfter(closeTime)) {
            continue;
          }

          adjustedOpenHour = {
            ...openHourVal,
            openHours: earliestAvailableTime.format("h:mma")
          };

          this.prepareFollowingDays.push({
            key: i === 0 ? null : newDateKey,
            date: newDateKey,
            value:
              i === 0
                ? this.translationService.translate("Menu.Date.Today")
                : i === 1
                  ? this.translationService.translate("Menu.Date.Tomorrow")
                  : newDateLabel,
            openHour: adjustedOpenHour
          });
        }

        // now check if current time/date is valid
         let dateTime: moment.Moment;

        if (this.order.orderDate && this.order.orderTime) {
          dateTime = moment(
            `${this.order.orderDate} ${this.order.orderTime}`,
            "YYYY-MM-DD HH:mm"
          );
        }
        else if (this.order.orderTime) {
          dateTime = moment(
            `${moment().format("YYYY-MM-DD")} ${this.order.orderTime}`,
            "YYYY-MM-DD HH:mm"
          );
        }
        else {
          dateTime = moment();
        }

        const day = this.prepareFollowingDays.find(x =>
          moment(x.date, "YYYY-MM-DD").isSame(dateTime, "day")
        );

        if (day) {
          const openTime = moment(
            `${day.date} ${day.openHour.openHours}`,
            "YYYY-MM-DD h:mma"
          );

          const closeTime = moment(
            `${day.date} ${day.openHour.closeHours}`,
            "YYYY-MM-DD h:mma"
          );

          let validDateTime = dateTime.isBetween(
            openTime,
            closeTime,
            undefined,
            "[]"
          );

          if(!validDateTime){
            let itemPreparationModal = await this.modalController.create({
              component: ItemPreparationModalComponent,
              componentProps: {
                menuItem: item,
                orderType: this.order._deliveryType
              },
              cssClass: 'item-preparation-modal'
            });

            itemPreparationModal.onWillDismiss()
            .then((result) => {
              if(result){
                this.order.orderDate = result.data.orderDate;
                this.datePickerChanged(this.order._deliveryType);
                this.order.orderTime = result.data.orderTime;
                this.timePickerChanged(this.store.id);
              }
            });

            await itemPreparationModal.present();

            return;
          }
        } else {
          let itemPreparationModal = await this.modalController.create({
            component: ItemPreparationModalComponent,
            componentProps: {
              menuItem: item,
              orderType: this.order._deliveryType
            },
            cssClass: 'item-preparation-modal'
          });

          itemPreparationModal.onWillDismiss()
          .then((result) => {
            if(result){
              this.order.orderDate = result.data.orderDate;
              this.datePickerChanged(this.order._deliveryType);
              this.order.orderTime = result.data.orderTime;
              this.timePickerChanged(this.store.id);
            }
          });

          await itemPreparationModal.present();

          return;
        }
      }

      //------------------------------------------------------------------------------


      //Adding the check for a third party inventory in stock information when it is enabled for the store
      if (this.store.useThirdPartyInventory) {
        if (item.item.externalPOSId != null) {
            //only do the check if the item has an id from the POS
            //check how many time we already have that item in the card, we must already check for the total of quantities we need
            let count: number = 1;

            this.order.orderItems.forEach(itemLoop => {
              
              if (item.itemId == itemLoop.itemId) {
                count += itemLoop.quantity;
              }

            });

            this.itemService.validateThirdPartyQuantities(this.store.id, item.item.externalPOSId, count).subscribe(success => {
              if (!success) {
                  item.item.isActive = false;
                  this.notAvailable(this.translationService.translate('Item.InventoryWarningHeader'), this.translationService.translate('Item.InventoryWarningContent'))
                  return;
                  console.log("not enough quantities");
              } else {
                this.proceedToItemDetail(item, chosenItemDetailCombination, chosenQuantity);
              }

            });
        } else {
          this.proceedToItemDetail(item, chosenItemDetailCombination, chosenQuantity);
        }
      } else {
        //console.log(item);
        this.proceedToItemDetail(item, chosenItemDetailCombination, chosenQuantity);
      }
      
      //------------------------------------------------------------------------------ 
    }


    async itemDetailDirect(item: any, chosenItemDetailCombination?: IItemDetailCombination, chosenQuantity?: number) {

      //Need to check this blog
	    //Table orders: allow user to look at menu but unable to add items to cart
      /*
      if(this.hideTableOrderCheckout){
        return;
      }
      */
    
      if(item){
        this.proceedToItemDetailNostore(item, chosenItemDetailCombination, chosenQuantity);
      }
      
      /*
      if(this.store){
        //Adding the check for a third party inventory in stock information when it is enabled for the store
        if (this.store.useThirdPartyInventory) {
          if (item.item.externalPOSId != null) {
              //only do the check if the item has an id from the POS
              //check how many time we already have that item in the card, we must already check for the total of quantities we need
              let count:number = 1;

              this.order.orderItems.forEach(itemLoop => {
                
                if (item.itemId == itemLoop.itemId) {
                  count += itemLoop.quantity;
                }

              });

              this.itemService.validateThirdPartyQuantities(this.store.id, item.item.externalPOSId, count).subscribe(success => {
                if (!success) {
                    item.item.isActive = false;
                    this.notAvailable(this.translateService.instant('Item.InventoryWarningHeader'), this.translateService.instant('Item.InventoryWarningContent'))
                    return;
                    console.log("not enough quantities");
                } else {
                  this.proceedToItemDetail(item, chosenItemDetailCombination, chosenQuantity);
                }

              });
          } else {
            this.proceedToItemDetail(item, chosenItemDetailCombination, chosenQuantity);
          }
        } else {
          //console.log(item);
          this.proceedToItemDetail(item, chosenItemDetailCombination, chosenQuantity);
        }
      } else {
        this.proceedToItemDetail(item, chosenItemDetailCombination, chosenQuantity, true);
      }
        */
      
    }
    async proceedToItemDetailNostore(item: any, chosenItemDetailCombination?: IItemDetailCombination, chosenQuantity?: number) {
      
      if(item.item)
      {  
        if(item.item.isInventoryActive && item.item.isInventoryExist && item.item.quantity == 0)
        {
          return;
        }
        if(!item.item.isActive)
        {
          return;
        }
      } else {
        if(!item.isActive || (item.quantity === 0 && item.isInventoryActive && item.isInventoryExist))
        {
          return;
        }
      }

      if (item.item == null && item.itemOptionCategories != null) {
        item.item = _.cloneDeep(item);
      }
      //reset the option._selected flag of every options
    
        item.item.itemOptionCategories.forEach(optionCategory => {
          optionCategory.options.forEach((option: any) => {
            option.option._selected = false;
          });
        });
      
     
  
      
      //Here the logic will be inserted 
      if(!item.item.isRetailItem)
      {
        this.cssClass = '';
      }
      if(item.item.isRetailItem)
      {
        this.cssClass = 'retail';
      }

      const dismissItemModal = (cancel: boolean, itemDetailCombination: itemDetailCombination, quantity: number,
        item: IStoreMenuCategoryItem, combinationPrice: number, cartOrderType: OrderType) => {
        modal.dismiss({
          cancel: cancel,
          itemDetailCombination: itemDetailCombination,
          quantity:  quantity,
          item: item,
          combinationPrice: combinationPrice,
          orderType: cartOrderType
        });

        
      };

      // recently added to fix the issue where the query parameters would seep into the orderType causing issues
      const hasQueryParams = this.router.url.includes('?'); // confirms that there is params in the URL

      var URLvalue = "";
      if(hasQueryParams) {
        const urlTree = this.router.parseUrl(this.router.url);
        const segments = urlTree.root.children['primary'].segments;
        URLvalue = segments[segments.length - 1].path;
      } else {
        URLvalue = this.router.url.split('/').pop()
      }

      const modal = await this.modalController.create({
        
        component: MenuItemDetailModalComponent,
        componentProps: {
          item: item,
          trackStoreId: this.trackStoreId,
          store: this.store,
          orderType: URLvalue,
          chosenQuantity: chosenQuantity,
          chosenItemDetailCombination: chosenItemDetailCombination,
          dismissItemModal: dismissItemModal
        },

        cssClass: this.cssClass
      });


      modal.onWillDismiss()
        .then((result) => {
          item.item.itemOptionCategories.forEach(optionCategory => {
            optionCategory.options.forEach((option: any) => {
              option.option.quantity = 0;
              if(optionCategory.chainItem){
                option.chainItemOptionCategories.forEach(chainItemOptionCategory => {
                  chainItemOptionCategory.options.forEach((chainItemOption: IStoreMenuItemOption) => {
                    chainItemOption.option.quantity = 0;
                    chainItemOption.option._selected = false;
                  });
                })
              }
            });
          });
         if(result.data == undefined || result.data == null)
         {
           localStorage.removeItem('editKey')
           return
         }

         this.orderType = "delivery";
         /*
         if(result.data.orderType)
         {
           this.orderType=result.data.orderType
         }
           */



         if(result.data.emptyCart) {
           this.order.orderItems = []
         }

         if(result.data)
         {
          if(result.data.itemDetailCombination)
          {
            this.itemDetailCombination = result.data.itemDetailCombination
            //this.quantity=1;
            this.retailQuantity = result.data.quantity;
            this.combinationPrice = result.data.combinationPrice;

            // add measurements to itemdetailcombination
            for(let combinations of result.data.item.item.itemDetailCombination){
              if(combinations.code === result.data.itemDetailCombination.code){
                for(let measurements of result.data.item.item.itemMeasurements){
                  if(measurements.id === combinations.measurementsId){
                    this.itemDetailCombination.measurementsId = measurements.id;
                    this.itemDetailCombination.measurements = measurements.measurements;
                  }
                }
              }
            }
          }
          else
          {
            this.combinationPrice = null;
            this.itemDetailCombination = null;
            this.retailQuantity = null;
          }

          if(result.data.item)
          {
            if(result.data.item.item.itemAvailableHour)
            {
              this.itemAvailableHour = result.data.item.item.itemAvailableHour;
            }
          }
      
          else 
          {
            this.itemAvailableHour = null;
          }
        
         }
          if (result.data)
          if(result.data.cancel)
            return;

          //console.log(item);
          //console.log(result);
          this.addItemToCart(item);
        });
      await modal.present();
    }

    async proceedToItemDetail(item: any, chosenItemDetailCombination?: IItemDetailCombination, chosenQuantity?: number) {

      if(item.item)
      {  
        if(item.item.isInventoryActive && item.item.isInventoryExist && item.item.quantity == 0)
        {
          return;
        }
        if(!item.item.isActive || (this.order._deliveryType == 'delivery' && this.store.isDoorDashDrive && !item.item.isActiveDoorDashDrive))
        {
          return;
        }
      } else {
        if(!item.isActive || (item.quantity === 0 && item.isInventoryActive && item.isInventoryExist))
        {
          return;
        }
      }

      if (item.item == null && item.itemOptionCategories != null) {
        item.item = _.cloneDeep(item);
      }
      //reset the option._selected flag of every options
    
      item.item.itemOptionCategories.forEach(optionCategory => {
        optionCategory.options.forEach((option: any) => {
          option.option._selected = false;
        });
      });
      
     
  
      
      //Here the logic will be inserted 
      if(!item.item.isRetailItem)
      {
        this.cssClass = '';
      }
      if(item.item.isRetailItem)
      {
        this.cssClass = 'retail';
      }

      const dismissItemModal = (cancel: boolean, itemDetailCombination: itemDetailCombination, quantity: number,
        item: IStoreMenuCategoryItem, combinationPrice: number, cartOrderType: OrderType) => {
        modal.dismiss({
          cancel: cancel,
          itemDetailCombination: itemDetailCombination,
          quantity:  quantity,
          item: item,
          combinationPrice: combinationPrice,
          orderType: cartOrderType
        });

        
      };


      // recently added to fix the issue where the query parameters would seep into the orderType causing issues
      const hasQueryParams = this.router.url.includes('?'); // confirms that there is params in the URL

      var URLvalue = "";
      if(hasQueryParams) {
        const urlTree = this.router.parseUrl(this.router.url);
        const segments = urlTree.root.children['primary'].segments;
        URLvalue = segments[segments.length - 1].path;
      } else {
        URLvalue = this.router.url.split('/').pop()
      }

      // Will create a split to use the new layout here using the new setting. With the new layout, we'll add the options as well as the item in 1 go.
      // -> use this new modal for it: MenuItemAllinoneModalComponent

      /*
      // this is the option component for reference.
      const modal = await this.modalController.create({
          cssClass: 'my-custom-modal-css',
           component: ItemOptionComponent,
           componentProps: {
             item: item,
             orderItem: this.currentItem,
             optionIndex: optionIndex,
             back: back,
             store: this.store,
             order: this.order
           }
         });
      */


      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // We'll split here. the "if (true)" needs to be replaced by the actual value that points to the right modal version from the setting

      var modal;

 
      if(this.settingService.configuration.uIoptions?.horizontalMenu) {
        // Currently works, only need to attach the options with the response here and skip item options selection

        // options component
        
        //const modal = await this.modalController.create({
        //  cssClass: 'my-custom-modal-css',
        //  component: ItemOptionComponent,
        //  componentProps: {
        //    item: item,
        //    orderItem: this.currentItem,
        //    optionIndex: optionIndex,
        //    back: back,
        //    store: this.store,
        //    order: this.order
        //  }
        //});

         
        let isTwoForOne = this.isTwoForOneItem(item.item);

        
        if(URLvalue == "pickup" || URLvalue == "delivery" || URLvalue == "shipping" || URLvalue == "table" || URLvalue == "seat") {
          this.orderType = URLvalue;
        }
        
        console.log(item);
        this.currentItem = {
          itemId: item.item.id,
          itemName: item.item.itemName,
          itemNumber: item.item.itemNumber,
          options: [],
          taxEligible: item.item.taxEligible,
          price: item.item.price,
          quantity: 1,
          allergies: "",
          note: "",
          _hidePrice: false,
          _chainItemId: null,
          itemDetailCombination: null,
          itemAvailableHour: item.item.itemAvailableHour,
          isDelivery: item.item.isDelivery,
          orderType: this.orderType,
          isAlcohol: item.item.isAlcohol,
          _originalPrice: item.item.price,
          _isTwoForOne: isTwoForOne,

          isFoodItem: item.item.isFoodItem,
          _relatedStoreId: this.trackStoreId
        };

        modal = await this.modalController.create({

          component: MenuItemAllinoneModalComponent,
          componentProps: {
            item: item,
            trackStoreId: this.trackStoreId,
            store: this.store,
            orderType: URLvalue,
            chosenQuantity: chosenQuantity,
            chosenItemDetailCombination: chosenItemDetailCombination,
            dismissItemModal: dismissItemModal,

            // these are to process the rest of the items including options
            orderItem: this.currentItem,
            order: this.order
          },
          // manually set cssClass for now
          cssClass: "menu-item-allinone-modal"
        });


        modal.onWillDismiss()
        .then((result) => {

          //here there's something to note. The item sent back may not be the same. It may be one of the selected subitems. we need to process it as if it was from "itemDetail" then resume
          console.log(result.data);
          console.log(result.data.selectedSubItem);

          // the "buy now" is a variable we use to know if we go straight to the checkout after we add to the cart or not
          this.buynow = result.data.buynow;

          var NewItem = result.data.selectedSubItem;
 
          ////////////////////////////////////////////////////////////////////////////////////////////////////////
          if(result.data.selectedSubItem) {
            if (NewItem.externalPOSId != null) {

              //only do the check if the item has an id from the POS
              //check how many time we already have that item in the card, we must already check for the total of quantities we need
              let count: number = 1;

              this.order.orderItems.forEach(itemLoop => {
                
                if (item.itemId == itemLoop.itemId) {
                  count += itemLoop.quantity;
                }

              });

              this.itemService.validateThirdPartyQuantities(this.store.id, NewItem.externalPOSId, count).subscribe(success => {
                if (!success) {
                    NewItem.isActive = false;
                    this.notAvailable(this.translationService.translate('Item.InventoryWarningHeader'), this.translationService.translate('Item.InventoryWarningContent'))
                    return;
                    console.log("not enough quantities");
                }

              });

              if(!NewItem.isActive || (NewItem.quantity === 0 && NewItem.isInventoryActive && NewItem.isInventoryExist)) {
                return;
              }
            }
          }

          

          

          ////////////////////////////////////////////////////////////////////////////////////////////////////////

          // the response:
          //this.modalCtrl.dismiss({
          //  cancel: false,
          //  itemDetailCombination: this.item.item.isRetailItem ? this.itemDetailCombination : null,
          //  quantity: this.selectedQuantity,
          //  item: this.item,
          //  combinationPrice: this.combinationPrice,
          //  orderType: orderType
          //});
          

          // will send item back (different item will be setup here -> main item mostly for display -> selected items will be to actually add to cart
          // example: cappuccino (main item) -> linked items (cappucino small "small", cappucino medium "medium", cappucino large "large"). Send the selected linked item back and add to cart.



          // i can still use the quantity here to know how many items were sent back to purchase
          if(result.data.selectedSubItem) { 
            // must not remove quantity for the sub items

            /*
            NewItem.itemOptionCategories.forEach(optionCategory => {
              optionCategory.options.forEach((option: any) => {
                if(option.option.quantity > 0) {
                  console.log("factual test");
                  console.log(option.option.quantity);
                  
                } else {
                  option.option.quantity = 0;
                  if(optionCategory.chainItem){
                    option.chainItemOptionCategories.forEach(chainItemOptionCategory => {
                      chainItemOptionCategory.options.forEach((chainItemOption: IStoreMenuItemOption) => {
                        chainItemOption.option.quantity = 0;
                        chainItemOption.option._selected = false;
                      });
                    })
                  }
                }
                
              });
            });
            */
          } else {
            item.item.itemOptionCategories.forEach(optionCategory => {
              optionCategory.options.forEach((option: any) => {
                option.option.quantity = 0;
                if(optionCategory.chainItem){
                  option.chainItemOptionCategories.forEach(chainItemOptionCategory => {
                    chainItemOptionCategory.options.forEach((chainItemOption: IStoreMenuItemOption) => {
                      chainItemOption.option.quantity = 0;
                      chainItemOption.option._selected = false;
                    });
                  })
                }
              });
            });
          }

          
          
          if(result.data == undefined || result.data == null)
          {

            localStorage.removeItem('editKey')
            return
          }
          if(result.data.orderType)
          {

            this.orderType = result.data.orderType
          }
          if(result.data.emptyCart)
          {

            this.order.orderItems = []
          }
          if(result.data)
          {

            // will always be null for now
            if(result.data.itemDetailCombination)
            {
              this.itemDetailCombination = result.data.itemDetailCombination
              //this.quantity=1;
              this.retailQuantity = result.data.quantity;
              this.combinationPrice = result.data.combinationPrice;

              // add measurements to itemdetailcombination
              for(let combinations of result.data.item.item.itemDetailCombination){
                if(combinations.code === result.data.itemDetailCombination.code){
                  for(let measurements of result.data.item.item.itemMeasurements){
                    if(measurements.id === combinations.measurementsId){
                      this.itemDetailCombination.measurementsId = measurements.id;
                      this.itemDetailCombination.measurements = measurements.measurements;
                    }
                  }
                }
              }

            } else {
              this.combinationPrice = null;
              this.itemDetailCombination = null;
              this.retailQuantity = null;
            }

            if(result.data.selectedSubItem) {
              if(result.data.selectedSubItem.itemAvailableHour)
              {
                this.itemAvailableHour = result.data.selectedSubItem.itemAvailableHour;
              }
            } else {
              if(result.data.item)
              {
                if(result.data.item.item.itemAvailableHour)
                {
                  this.itemAvailableHour = result.data.item.item.itemAvailableHour;
                }
              } else {
                this.itemAvailableHour = null;
              }
            }
          
          }
          
          if (result.data) {
            if(result.data.cancel) {
              return;
            }
          }
          

          //console.log(item);
          //console.log(result);

          // this essentially checks if we want to place a different item then the original one we looked at in the cart.
          if(result.data.selectedSubItem) {
            NewItem.itemOptionCategories.forEach(optionCategory => {
              optionCategory.options.forEach((option: any) => {
                if(option.option.quantity > 0) {
                  //console.log("factual test");
                  //console.log(option.option.quantity);
                  // just leave it to skip for now

                } else {
                  option.option.quantity = 0;
                  if(optionCategory.chainItem){
                    option.chainItemOptionCategories.forEach(chainItemOptionCategory => {
                      chainItemOptionCategory.options.forEach((chainItemOption: IStoreMenuItemOption) => {
                        chainItemOption.option.quantity = 0;
                        chainItemOption.option._selected = false;
                      });
                    })
                  }
                }
                
              });
            });

            console.log(NewItem);
            console.log(NewItem);

            // i might need to rebuild the item:
            var itemDerived: IStoreMenuCategoryItem = {
              itemId: NewItem.id,
              item: NewItem,
              parentItem: item
            }

            this.addItemToCart(itemDerived, result.data.foodQuantity, true);
          } else {

            this.addItemToCart(item);
          }
        });
      } else {

        // needs to shift to the new modal item looks here
        modal = await this.modalController.create({
          
          component: MenuItemDetailModalComponent,
          componentProps: {
            item: item,
            trackStoreId: this.trackStoreId,
            store: this.store,
            orderType: URLvalue,
            chosenQuantity: chosenQuantity,
            chosenItemDetailCombination: chosenItemDetailCombination,
            dismissItemModal: dismissItemModal
          },

          cssClass: this.cssClass
        });


        modal.onWillDismiss()
          .then((result) => {
            console.log(result);

            item.item.itemOptionCategories.forEach(optionCategory => {
              optionCategory.options.forEach((option: any) => {
                option.option.quantity = 0;
                if(optionCategory.chainItem){
                  option.chainItemOptionCategories.forEach(chainItemOptionCategory => {
                    chainItemOptionCategory.options.forEach((chainItemOption: IStoreMenuItemOption) => {
                      chainItemOption.option.quantity = 0;
                      chainItemOption.option._selected = false;
                    });
                  })
                }
              });
            });
            
            if(result.data == undefined || result.data == null)
            {
              localStorage.removeItem('editKey')
              return
            }
            if(result.data.orderType)
            {
              this.orderType = result.data.orderType
            }

            if(result.data.emptyCart) {
              this.order.orderItems = []
            }

            if(result.data)
            {
              if(result.data.itemDetailCombination)
              {
                this.itemDetailCombination = result.data.itemDetailCombination
                //this.quantity=1;
                this.retailQuantity = result.data.quantity;
                this.combinationPrice = result.data.combinationPrice;

                // add measurements to itemdetailcombination
                for(let combinations of result.data.item.item.itemDetailCombination){
                  if(combinations.code === result.data.itemDetailCombination.code){
                    for(let measurements of result.data.item.item.itemMeasurements){
                      if(measurements.id === combinations.measurementsId){
                        this.itemDetailCombination.measurementsId = measurements.id;
                        this.itemDetailCombination.measurements = measurements.measurements;
                      }
                    }
                  }
                }
              }
              else
              {
                this.combinationPrice = null;
                this.itemDetailCombination = null;
                this.retailQuantity = null;
              }

              if(result.data.item)
              {
                if(result.data.item.item.itemAvailableHour)
                {
                  this.itemAvailableHour = result.data.item.item.itemAvailableHour;
                }
              } else if (result.data.subItem){
                if(result.data.subItem.itemAvailableHour)
                {
                  this.itemAvailableHour = result.data.subItem.itemAvailableHour;
                }
                result.data.subItem.item = _.cloneDeep(result.data.subItem);
                this.addItemToCart(result.data.subItem, result.data.quantity);
                return;
              }
          
              else 
              {
                this.itemAvailableHour = null;
              }
            
            }
            if (result.data)
            if(result.data.cancel)
              return;

            //console.log(item);
            //console.log(result);
            this.addItemToCart(item, result.data.quantity);
          });


      }
      

      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


      await modal.present();
    }

    consolidateCart(store: IStore, orderType: OrderType) {
      if(this.order.store == null){
        this.getStore(store.id);
        localStorage['StoreId'] = store.id;

        //this.store = store;
        this.order.store = store;
        this.order._deliveryType = orderType;

        for(var i = 0; i < this.order.orderItems.length; i++){
          this.order.orderItems[i].orderType = orderType
        }
      }

      /*
      this.getStore(store.id);
      localStorage['StoreId']=store.id;

      //this.store = store;
      this.order.store = store;
      this.order._deliveryType = orderType;

      for(var i = 0; i < this.order.orderItems.length; i++){
        this.order.orderItems[i].orderType = orderType
      }
      console.log(store);
      console.log(this.order);
      */
      
    }

    async addItemToCart(item: IStoreMenuCategoryItem, foodQuantity: number = 1, includeAllOptions: boolean = false) {
      // this is when we add the item and start the option selection process


      let isTwoForOne = this.isTwoForOneItem(item.item);
      this.currentItem = {
        itemId: item.item.id,
        itemName: item.item.itemName,
        itemNumber: item.item.itemNumber,
        options: [],
        taxEligible: item.item.taxEligible,
        price: this.combinationPrice ? this.combinationPrice :  item.item.price,
        //quantity: this.retailQuantity ? +this.retailQuantity : 1,
        quantity: this.retailQuantity ? +this.retailQuantity : foodQuantity, // this changes the number of items placed (not just for retail)
        allergies: "",
        note: "",
        _hidePrice: false,
        _chainItemId: null,
        itemDetailCombination: this.itemDetailCombination,
        itemAvailableHour: this.itemAvailableHour,
        isDelivery: item.item.isDelivery,
        orderType: this.orderType,
        isAlcohol: item.item.isAlcohol,
        _originalPrice: this.combinationPrice ? this.combinationPrice :  item.item.price,
        _isTwoForOne: isTwoForOne,

        isFoodItem: item.item.isFoodItem,
        _relatedStoreId: this.trackStoreId,


        description: item.item.description,
        descriptionExtended: item.item.descriptionExtended,
        itemImageShortName: item.item.itemImageShortName,
        _itemImage: item.item._itemImage,
        _parentItem: item.parentItem
      };

      // for the all in 1 menu, the item comes with the options. as such, i need to add them all in one go here.
      if(includeAllOptions) {
        item.item.itemOptionCategories.forEach(optionCategory => {
          optionCategory.options.forEach((option: IStoreMenuItemOption) => {
            if(option.option.quantity > 0) {
              let o: IOrderItemOption = {
                quantity: option.option.quantity,
                optionId: option.option.id,
                itemId: option.itemId,
                price: option.option.price,
                name: option.option.name,
                itemNumber: item.item.itemNumber,
                itemOptionCategoryId: optionCategory.id,
                _parentOptionCategoryId: optionCategory.id,
              }
              this.currentItem.options.push(o);
              
            }
            option.option.quantity = 0;
            if(optionCategory.chainItem){
              option.chainItemOptionCategories.forEach(chainItemOptionCategory => {
                chainItemOptionCategory.options.forEach((chainItemOption: IStoreMenuItemOption) => {
                  chainItemOption.option.quantity = 0;
                  chainItemOption.option._selected = false;
                });
              })
            }
          });
        });
      }
      

      if(!this.storeService.getSelectedStore){
        console.log("selecting store post item selection");
        const modal = await this.modalController.create({
          component: StoreListModalComponent,
          cssClass: 'store-popup-model',
          componentProps: {
            isTableOrder: false,
            disableHeader: true
          }
        });

        //navigate to the first store this merchant has so it can lay a menu in the background (only if it's not already on a menu)
        if (!this.router.url.includes('/stores/menu')) {
          this.storeService.getStores().subscribe((data: IStore[]) => {
            var stores = data;
  
            this.navCtrl.navigateRoot('/stores/menu/' + stores[0].id + '/pickup');
          });
        }

        /*
        modal.onWillDismiss()
          .then((result) => {
            
        });*/
      
        await modal.present();

        const { data } = await modal.onDidDismiss();

        if(data?.route){
          this.navCtrl.navigateRoot(['/stores' + data.route]);
          this.storeService.setSelectedStore = true;

          // fix all other order to be on the same store
          // change the "this.store" here to choose the new store
          
          // this.order

          /*
          this.router.navigate(['/menu'], {
            queryParams: {
              storeId: data.route[1],
              orderType: data.route[2]
            }
          });
          */
        }
      }

      // itemDetailCombination is always going to be null for now
      if(this.currentItem.itemDetailCombination) {
        /* rm
        console.log("selecting store post item selection");
        const modal = await this.modalController.create({
          component: StoreListModalComponent,
          cssClass: 'store-popup-model',
          componentProps: {
            isTableOrder: false,
            disableHeader: true
          }
        });

        //navigate to the first store this merchant has so it can lay a menu in the background (only if it's not already on a menu)
        if (!this.router.url.includes('/stores/menu')) {
          this.storeService.getStores().subscribe((data: IStore[]) => {
            var stores = data;
  
            this.navCtrl.navigateRoot('/stores/menu/' + stores[0].id + '/pickup');
          });
        }
        */






        /*
        modal.onWillDismiss()
          .then((result) => {
            
        });*/
      





        /* rm
        await modal.present();

        const { data } = await modal.onDidDismiss();

        if(data?.route){

          this.navCtrl.navigateRoot(['/stores' + data.route]);
          this.storeService.setSelectedStore = true;
*/






          // fix all other order to be on the same store
          // change the "this.store" here to choose the new store
          
          // this.order

          /*
          this.router.navigate(['/menu'], {
            queryParams: {
              storeId: data.route[1],
              orderType: data.route[2]
            }
          });
          */
        //}
      //}

      // itemDetailCombination is always going to be null for now
      //if(this.currentItem.itemDetailCombination) {
        if(localStorage['editKey'])
        {
          this.itemRequestModal(item);
          return;
        }
      }


      // will need to create a split here to use the new layout when we enable the setting. (options added in 1 modal instead of multiple)

      //Add an item category as first step asking for allergies/request
      this.configureItemOptions(item);

    }

    async configureItemOptions(item: IStoreMenuCategoryItem, optionIndex: number = 0, back: boolean = false) {  
      // temporary fail safe for the new UI this prevents us from going to the options 
      if (item.item.itemOptionCategories.length > 0 && !this.settingService.configuration.uIoptions?.horizontalMenu) {

        // this is to disable it if we go to options
        this.buynow = false;

        const modal = await this.modalController.create({
          cssClass: 'my-custom-modal-css',
          component: ItemOptionComponent,
          componentProps: {
            item: item,
            orderItem: this.currentItem,
            optionIndex: optionIndex,
            back: back,
            store: this.store,
            order: this.order
          }
        });
  
        modal.onWillDismiss()
        .then((result) => {
          // this is when an item option has been selected
          this.analytics.sendItemUpdate(false, item, result, this.order, false, optionIndex, back);

          //Result now containt the optionIndex  and a back flag  
          if (!result.data || result.data.cancel) {
          
            item.item.itemOptionCategories.forEach(optionCategory => {
              optionCategory.options.forEach((option: IStoreMenuItemOption) => {
                option.option.quantity = 0;
                if(optionCategory.chainItem){
                  option.chainItemOptionCategories.forEach(chainItemOptionCategory => {
                    chainItemOptionCategory.options.forEach((chainItemOption: IStoreMenuItemOption) => {
                      chainItemOption.option.quantity = 0;
                      chainItemOption.option._selected = false;
                    });
                  })
                }
              });
            });
            
            return;
          }

      
          console.log(result.data);
            
          if (result.data.back) { 
            if(result.data.optionIndex == -1){
              this.itemDetail(item, this.currentItem.itemDetailCombination, this.currentItem.quantity);
              return;
            }          
            this.configureItemOptions(item, result.data.optionIndex, true);
            return;
          }

          if(result.data.chainItemId){
            result.data.option = result.data.option.filter((option) => {
              if(option.itemId == result.data.chainItemId || option._chainItemId == result.data.chainItemId){
                return true;
              } else {
                return false;
              }
            });
          }

          let optionNumber = result.data.option.findIndex(option => option.quantity > 0);
          if(result.data.option && result.data.option[0] && result.data.option[0].itemDetailCombination && result.data.option[optionNumber] && result.data.option[optionNumber].quantity > 0){
            this.configureItemOptionDetail(item, result.data.optionIndex, result.data.option[optionNumber]);
            return;
          }

          if(result.data.option && result.data.option[0] && result.data.option[0].itemDetailCombination && optionNumber == -1 ){
            this.itemRequestModal(item,optionIndex);
            return;
          }

          //Now check if the category already exist to remove them before pushing same category infos, 
          //mean the user went back in the seletections to make changes          
          for(let i = this.currentItem.options.length -1; i >= 0 && result.data.option.length > 0; i--) {
            if (this.currentItem.options[i]._parentOptionCategoryId == result.data.categoryId) {
              this.currentItem.options.splice(i, 1);
            }
          }

          result.data.option.forEach(option => {
            let o: IOrderItemOption = {
              quantity: option.quantity,
              optionId: option.id,
              itemId: option.itemId,
              price: option.price,
              name: option.name,
              itemNumber: option.itemNumber,
              itemOptionCategoryId: option._optionCategoryId ? option._optionCategoryId : result.data.categoryId,
              _parentOptionCategoryId: result.data.categoryId
            }
            this.currentItem.options.push(o);
          });

          
          if (result.data.optionIndex < item.item.itemOptionCategories.length - 1) {
            this.configureItemOptions(item, result.data.optionIndex + 1);
            return;
          }

          if (result.data.chainItem) {
            //Set that we need to chain to an item when all questions are done
            // this.currentItem._chainItem
      
          // this.currentItem._chainItem = true;
          }

          if (!this.currentItem._hidePrice) {
            //Only set it when it is not already true. We dont want another option to reset it to false
            this.currentItem._hidePrice = result.data.hidePrice;
          }

          //No more push the orderItems, always ask for allergies at the end
          // this.order.orderItems.push(this.currentItem);
          //this.currentItem = null;
          if (!item.item.skipAllergies) {
            this.itemRequestModal(item,optionIndex);
          } else {

            if(localStorage[CACHE_KEY]) {
              this.order.orderItems = (JSON.parse(localStorage[CACHE_KEY]));
            }
            let date = new Date();
            if(localStorage['editKey']) {
              this.order.orderItems[localStorage['editKey']] = this.currentItem; 
            }
            else {           
              this.order.orderItems.push(this.currentItem);
              this.checkTwoForOneDiscounts();
            }

            localStorage[CACHE_KEY] = JSON.stringify(this.order.orderItems);

            localStorage['TimeLimit'] = date.getDate();

            if(localStorage.getItem('StoreId') == null) {
              localStorage['StoreId'] = this.trackStoreId;
            }
            this.checkTwoForOnePopup(this.currentItem.itemId, this.currentItem.orderType);
            this.currentItem = null;
          }
            
        });


        await modal.present();


      } else if (optionIndex == -1) {
        this.itemDetail(item, this.currentItem.itemDetailCombination, this.currentItem.quantity);
        return;

        // with the new look, we actually skip that as it'll be setup in a different section (aka its own page and with links in the "read more")


      } else if (!item.item.skipAllergies && !this.settingService.configuration.uIoptions?.horizontalMenu) {
        await this.itemRequestModal(item,optionIndex);
      } else {

        //to have options i need them here and not recetted

        this.order.orderItems.push(this.currentItem);

        this.checkTwoForOneDiscounts();
        localStorage[CACHE_KEY] = JSON.stringify(this.order.orderItems);


        if(localStorage.getItem('StoreId') == null){
          localStorage['StoreId'] = this.trackStoreId;
        }
        this.checkTwoForOnePopup(this.currentItem.itemId, this.currentItem.orderType);
        this.currentItem = null;

        // use this to directly send to cart (only for homers UI for now and if "buy now" was selected). only the mobile cart is triggered for now
        if(this.buynow) {
          this.cart()

          //this.desktopCart();
        }
      }
    }

    //step-2
    async itemRequestModal(item: IStoreMenuCategoryItem = null, optionIndex = null) {
      console.log(this.currentItem);

      // skip request if retail item
      if(this.currentItem.itemDetailCombination){

        if(localStorage[CACHE_KEY])
        {
          this.order.orderItems = (JSON.parse(localStorage[CACHE_KEY]));
        }
        let date = new Date();
        if(localStorage['editKey'])
        {
          if(localStorage['editOptionKey']){
            localStorage.removeItem('editOptionKey');
          } else {
            this.currentItem.options = this.order.orderItems[localStorage['editKey']].options;
          }
          this.order.orderItems[localStorage['editKey']] = this.currentItem;
          localStorage.removeItem('editKey');
        }
        else{
          let retailExists = false;
          for (let i = 0; i < this.order.orderItems.length; i++) {
            if(this.order.orderItems[i].itemDetailCombination){
              if (this.order.orderItems[i].itemDetailCombination.code == this.currentItem.itemDetailCombination.code
                && this.order.orderItems[i].orderType == this.currentItem.orderType) {
                retailExists = true;
                this.order.orderItems[i].quantity += this.currentItem.quantity;
                this.currentItem.options.forEach(currentItemOption => {
                  let index = this.order.orderItems[i].options.findIndex( option => option.itemId == currentItemOption.itemId &&
                    ((option.itemDetailCombination ? option.itemDetailCombination.code : null)  == 
                    (currentItemOption.itemDetailCombination ? currentItemOption.itemDetailCombination.code : null))
                  );
                  if(index != -1){
                    let totalQuantity = +this.order.orderItems[i].options[index].quantity + +currentItemOption.quantity;
                    this.order.orderItems[i].options[index].quantity = totalQuantity;
                  } else {
                    this.order.orderItems[i].options.push(currentItemOption);
                  }
                }); 
                break;
              }
            }
          }
          if(!retailExists){
            this.order.orderItems.push(this.currentItem);
            this.checkTwoForOneDiscounts();
          }
          retailExists = false;
        }
        
        localStorage[CACHE_KEY] = JSON.stringify(this.order.orderItems);
        localStorage['TimeLimit'] = date.getDate();
        // when editing an item, don't change the store in which the cart belongs to
        if(localStorage.getItem('StoreId') == null){
          localStorage['StoreId'] = this.trackStoreId;
        }
        this.checkTwoForOnePopup(this.currentItem.itemId, this.currentItem.orderType);
        this.currentItem = null;
        return;
      }
      

      const requestModal = await this.modalController.create({
        component: ItemRequestComponent,
        componentProps: {
          item: item,
          optionIndex: optionIndex,
          orderItem: this.currentItem,
        }
      });
  
      requestModal.onWillDismiss()
        .then(async (result) => {
          if(result.data)
          {
            if (result.data.cancel) {
              return;
            } 
            if(result.data.back)
            {
              /*if(result.data.orderItem.itemDetailCombination)
              {
                this.modalController.create({
                  component: MenuItemDetailModalComponent,
                  componentProps: {
                    item: item,
                    trackStoreId: this.trackStoreId,
                    store: this.store,
                    orderType: this.router.url.split('/').pop()
                  },
                  cssClass: 'retail'
                }).then(modal=>{
                  modal.present();
                  modal.onWillDismiss().then(result=>{
                    if(result.data==undefined || result.data==null)
                    {
                      localStorage.removeItem('editKey');
                      return;
                    }
                    if (result.data.cancel) {
                      return;
                    } 
                    this.currentItem = {
                      itemId: result.data.item.item.id,
                      itemName: result.data.item.item.itemName,
                      itemNumber: result.data.item.item.itemNumber,
                      options: [],
                      taxEligible: result.data.item.item.taxEligible,
                      price: result.data.item.item.price,
                      quantity: result.data.quantity,
                      allergies: "",
                      note: "",
                      _hidePrice: false,
                      _chainItemId: null,
                      itemDetailCombination: this.itemDetailCombination,
                      itemAvailableHour: this.itemAvailableHour,
                      isDelivery: result.data.item.item.isDelivery,
                      orderType: this.orderType
                    };
                    this.itemRequestModal(item,0);
                })
                })
                return;
              }*/

              this.currentItem = result.data.orderItem;
              this.configureItemOptions(result.data.item,result.data.optionIndex, result.data.back ? true : false);
              return;
            }

            /* if (item.item.itemOptionCategories.length > 0) {
                await this.configureItemOptions(item);
              } else {*/
           
            if(localStorage[CACHE_KEY])
            {
              this.order.orderItems = (JSON.parse(localStorage[CACHE_KEY]));
            }


            //////////////////////////////////////////////////////////////////////////////////////////////
            // this only checks if the item is actually being edited or not. (undefined means not edited)
            var editeditem = false;
            if(localStorage['editKey'] != undefined){
              editeditem = true;
            }
            //////////////////////////////////////////////////////////////////////////////////////////////
       
            let date = new Date();
            if(localStorage['editKey'])
            {
              this.order.orderItems[localStorage['editKey']] = this.currentItem;
            }
            else {
              /*for(let i=0;i<this.retailQuantity;i++)
              {
                this.order.orderItems.push(this.currentItem);
              }
              this.retailQuantity=1;*/   
              
              this.order.orderItems.push(this.currentItem);
              this.checkTwoForOneDiscounts();
            }


            //////////////////////////////////////////////////////////////////////////////////////////////
            // this assigns a cartID to all items based on IDs saved in localstorage
            if(this.settingService.configuration.enableKPI) {
              if(!editeditem){
                if(this.order.orderItems.length == 1){
                  // setup the id here and set it in local storage
                  localStorage.setItem('CurrentCartID', await this.analytics.processCartID("active").toPromise());

                  this.order.orderItems[0]["cartID"] = localStorage.getItem('CurrentCartID');
                } else {
                  // setup id to all other items but with the localstorage
                  this.order.orderItems[this.order.orderItems.length - 1]["cartID"] = localStorage.getItem('CurrentCartID');
                }
              } else {
                // this ensure that the ID is set properly to edited items (failsafe but it shouldn't be needed)
                this.order.orderItems[localStorage['editKey']]["cartID"] = localStorage.getItem('CurrentCartID');
              }

            }
            //////////////////////////////////////////////////////////////////////////////////////////////
            localStorage[CACHE_KEY] = JSON.stringify(this.order.orderItems);
            localStorage['TimeLimit'] = date.getDate();


            //////////////////////////////////////////////////////////////
            // this checks if the item was added without a store. if this is the case, it'll open the store list automatically
 
            if(this.order.store == null) {
              const loader = await this.loaderService.create();
      
              this.itemService.getStoresWithSpecificItem(item.itemId, this.settingService.getMerchantId(), item.item.externalProviderType).subscribe(async storeWithSpecifiedItem=>{
                await loader.dismiss();

                const modal = await this.modalController.create({
                  component: (await import('src/app/store/modals/store-list-modal/store-list-modal.component')).StoreListModalComponent,
                  cssClass: 'store-popup-model',
                  componentProps: {
                    isTableOrder: false,
                    disableHeader: true,
                    storeWithOrderItem: storeWithSpecifiedItem,
                  }
                });
              
                await modal.present();
        
                const { data } = await modal.onDidDismiss();
        
                if(data?.route){
                  this.navCtrl.navigateRoot(['/stores' + data.route]);
                }
                
              });
              

              
            }
            //////////////////////////////////////////////////////////////


            // when editing an item, don't change the store in which the cart belongs to
            if(localStorage.getItem('StoreId') == null){
              localStorage['StoreId'] = this.trackStoreId;
            }
           // localStorage['storeId']=JSON
            /*if (this.currentItem._chainItem) {
              //TODO Delayed for later
              //Trigger the new item to chain
              this.currentItem.
              this.currentItem.options.forEach(option => {})
              this.itemDetail()
            }*/
  
            this.checkTwoForOnePopup(this.currentItem.itemId, this.currentItem.orderType);
            this.currentItem = null;

            console.log("added to cart");
            console.log(this.order);
            //send to analytics that the item has been completed and will now be in the cart
            this.analytics.sendItemUpdate(false, item, null, this.order, false, null, null, "itemToCart", true);
          }
          else
          {
            localStorage.removeItem('editKey');
          }
        });
      
      await requestModal.present();
    }

    async configureItemOptionDetail(item: IStoreMenuCategoryItem, optionIndex: number, option: any, chosenItemDetailCombination?: IItemDetailCombination, chosenQuantity?: number){
      const modal = await this.modalController.create({
        component: MenuItemOptionDetailModalComponent,
        componentProps: {
          item: item,
          optionIndex: optionIndex,
          orderItem: this.currentItem,
          option: option,
          chosenQuantity: chosenQuantity,
          chosenItemDetailCombination: chosenItemDetailCombination
        },
        cssClass: 'option-retail-modal-css'
      });
 
       modal.onWillDismiss()
         .then((result) => {
           if (!result.data || result.data.cancel) {
            localStorage.removeItem('editOptionKey');
            return;
           }
  
           if (result.data.back) {
             this.configureItemOptions(item);
             return;
           }

           if(result.data.option){
            if(result.data.itemDetailCombination){
              // add measurements to itemdetailcombination
              for(let combinations of result.data.option.itemDetailCombination){
                if(combinations.code === result.data.itemDetailCombination.code){
                  for(let measurements of result.data.option.itemMeasurements){
                    if(measurements.id === combinations.measurementsId){
                      result.data.itemDetailCombination.measurementsId = measurements.id;
                      result.data.itemDetailCombination.measurements = measurements.measurements;
                    }
                  }
                }
              }
            }

            let newOption = {
              quantity: result.data.quantity,
              optionId: result.data.option.id,
              itemId: result.data.option.itemId,
              price: result.data.option.price,
              name: result.data.option.name,
              itemNumber: result.data.option.itemNumber,
              itemOptionCategoryId: item.item.itemOptionCategories[0].id,
              itemDetailCombination: result.data.itemDetailCombination ? result.data.itemDetailCombination : null
            };

            if(localStorage['editOptionKey']){
              this.currentItem.options[localStorage['editOptionKey']] = newOption;
            } else {
              this.currentItem.options.push(newOption);
            }
           }

           this.itemRequestModal(item);
         });
 
       await modal.present();
    }
  
    //logic to get name
    // getName()
    // { if(localStorage["StoreId"])
    // {
    //   this.storeService.getStore(localStorage["StoreId"]).pipe(
    //     first()
    //   ).subscribe(data=>{
    //     this.storeName=data.displayName;
    //   })
    // }
    // return;
    // }
    //



    //For push purposes check this function out
    async timePickerChanged(storeId: string) {



      if (this.order.orderDate != null && this.order.orderTime == null) {
        //During refresh, just skip validation
        return;
  
      }
  
      //This means order now for ASAP
      if (this.order.orderDate == null && this.order.orderTime == null) {
        if(!this.store._disabled){
          this.storeClosed = false;
          this.getMenu(storeId);
        }
        return;
      }
  
      //If the time is past midnight, add a day to the selected day 
    



      ///////////////////////////////////////////////////////////////////////
      //disabled this at the request of anthony. unsure why we're skiping a day if it's within 12h am to 4 am


      /*
      let orderTimeMoment = moment(this.order.orderTime, 'hh:mm');
      let beforeTime = moment("00:00", 'hh:mm');
      let limitTime = moment("04:00", 'hh:mm');

      //When the orderTime is between midnight and 4AM, we consider it the closing time and add 1 day to the selected date
      if (orderTimeMoment.isBetween(beforeTime, limitTime, undefined, '[]')) {
        this.dateAutoChanged = true;
        if (!this.order.orderDate) {
          this.order.orderDate = moment().add(1, 'day').format("yyyy-MM-DD").toString();
        } else {
          this.order.orderDate = moment(this.order.orderDate).add(1, 'day').format("yyyy-MM-DD").toString();
        }       
      }
      */
      ///////////////////////////////////////////////////////////////////////




      //Order today for time
      if (this.order.orderDate == null && this.order.orderTime != null) {
        this.storeClosed = false;
        this.getMenu(storeId);
        return;
      }
  
        //Date and time have been selected, check if available
      if (this.order.orderDate != null && this.order.orderTime != null && this.storeService.isStoreOpenSpecificDayAndTime(this.store, this.order.orderDate, this.order.orderTime)) {
        this.storeClosed = false;
        this.getMenu(storeId); 
        return;
      } else {       
        this.storeClosed = true;
        this.menu = null;
      } 
      
      if(this.storage['previewMenuMode']){
        if(this.order.orderDate != null && this.order.orderTime != null){
          //let timeMenu = moment(`${moment(this.order.orderDate).format('yyyy-MM-DD')} ${this.order.orderTime}`);
          //this.getMenu(storeId);
          //this.menu = ;
         this.getFutureMenu(storeId);

          //this.getFutureMenu(storeId);
          
          //this.getMenu(storeId); // review this makes the whole process very very slow
          
          // this.menuList.forEach(element => {
          //   //console.log(moment(element.deployDate).format("yyyy-MM-DD hh:mm"));
          //   if( moment(element.deployDate) <= timeMenu ){ //moment(this.order.orderDate).format("yyyy-MM-DD") && moment(element.deployDate).format("hh:mm") <= this.order.orderTime){
          //     if(this.menu == null || moment(this.menu.deployDate) <= moment(element.deployDate)){
          //       //console.log(this.menu);
          //       this.menu = element;
          //     }
          //   }
          // });
          // //this.menu = //this.menuList.find(t => moment(t.deployDate).format("yyyy-MM-DD") <=  moment(this.order.orderDate).format("yyyy-MM-DD") && moment(t.deployDate).format("hh:mm") <= this.order.orderTime);
          // if(this.menu != null){
          //   this.loadOverlayMenu(this.menu);
          //   this.storeClosed = false;
          // }
        }
        
      }
    }
    
    async getStore(storeId: string, address: IAddress = null,itemId = null, tableAlert: HTMLIonAlertElement = null) {
      const loader = await this.loaderService.create();

      return new Promise<void>((resolve, reject) => {


        this.storeService.getStore(storeId)
        .pipe(finalize(async () => {
          await loader.dismiss();
        }))
        .subscribe((store) => {
          this.store = store;  
      
          /*if(!this.store.allowDelivery && this.order._deliveryType=='delivery')
          {
            this.router.navigateByUrl('/stores');
          }*/

          //console.log(store);
          //Last available time should be at closing time

          //console.log(storeId);
          this.storeService.setOpeningHours(store);
          this.getFollowingDates(store);
        
          this.store.deliveryPrice = JSON.parse(localStorage.getItem("deliveryPrice"));
        /* this.storage.get("deliveryPrice").then((val: number) => {
            this.store.deliveryPrice = val;
          });*/
          if(this.storage['previewMenuMode']){
            this.getFutureMenu(storeId);
          }else if(!this.store._disabled){
            this.getMenu(storeId, itemId);
          }
          // if (!this.store._disabled && !this.storage['previewMenuMode']) {
          //   this.getMenu(storeId,itemId);
          // }else if(!this.store._disabled && this.storage['previewMenuMode']){
          //   this.getFutureMenu(storeId,itemId)
          // }
    
            //test values
          //  this.store.isDoorDashDrive = true;
            // this.store._disabledDelivery = true;
          if(tableAlert && store.tableOrderConfig && store.tableOrderConfig.useSecureOrders && 
            store.tableOrderConfig.secureOrdersTime > 0 && localStorage['tableOrders']){
            let preOrders: IPlacePreOrderBase[] = JSON.parse(localStorage['tableOrders']);
            preOrders = preOrders.filter(order => order.storeId == store.id);
            if(preOrders.length > 0 ){
              let now = new Date();
              let lastOrderDate = preOrders[preOrders.length - 1]._orderDate;
              let differenceInMinutes = (now.getTime() - new Date(lastOrderDate).getTime()) / (1000 * 60);

              if (differenceInMinutes < store.tableOrderConfig.secureOrdersTime) {
                this.notAvailable("Ordering unavailable", "There is already an order placed at this table but you can still look at the menu.");
                this.hideTableOrderCheckout = true;

                resolve();
                return;
              }
            }
          }
          if(tableAlert){
            tableAlert.present();
          }

          this.hideTableOrderCheckout = false;

          resolve();
        });

      });
    } 

    async loadOverlayMenu(menu: IStoreMenu){
      console.log(menu)
      this.menu = menu;
      this.setMenuImages(menu)
      this.itemColors=[];
      this.itemSize=[];
      this.itemCategories=[];
      this.itemSubCategories=[];
      this.itemBrands=[];
      let arrCat=[],arrSub=[],arrDep=[],arrColors=[],arrSizes=[],arrBrands=[],arrBrands2=[];
      if(this.menu.storeMenuCategories)
      {
        this.menu.storeMenuCategories.map(storeMenu=>{

          storeMenu.storeMenuCategoryItems.map(item=>{
           
  
            arrColors=arrColors.concat(item.item.itemColors);
            arrSizes=arrSizes.concat(item.item.itemSizes);
            arrDep=arrDep.concat(item.item.itemDepartments);
            arrCat=arrCat.concat(item.item.itemCategories);
            arrSub=arrSub.concat(item.item.itemSubCategories);
            if(item.item.itemBrandId)
            {
              arrBrands2=arrBrands2.concat(item.item.itemBrandId);
            }
            item.subItems.map(subItem=>{
              arrColors=arrColors.concat(subItem.itemColors);
              arrSizes= arrSizes.concat(subItem.itemSizes);
              arrDep=arrDep.concat(subItem.itemDepartments);
              arrCat=arrCat.concat(subItem.itemCategories);
              arrSub=arrSub.concat(subItem.itemSubCategories);
            })
          })
        
       })
    
      }
     let uniqueBrandsId=this.getUniqueBrands(arrBrands2);
     uniqueBrandsId.map(id=>{
      this.itemBrands.push(this.itemBrandService.itemBrands.find(brand=>brand.id==id))
     })
      this.itemColors=this.getUniqueStrings(arrColors);
      this.itemSize=this.getUniqueStrings(arrSizes);
      this.menuDepartments=this.getUniqueValues(arrDep);
      this.itemCategories=this.getUniqueValues(arrCat);
      this.itemSubCategories=this.getUniqueValues(arrSub);
      this.showTimeSelector = false;
      this.menuFullImages();
    }

    async getFutureMenu(storeId: string,itemId=null){
      //this.getMenu(storeId);
      //let menuList ;
      //const loader = await this.loaderService.create();
      await this.storeService.getFutureMenu(storeId, this.order.orderDate, this.order.orderTime)
        .subscribe((menu: IStoreMenu[]) => {
          //console.log(menu);
          //this.setMenuImages(menu[0])

          this.menuList = menu;
          let timeMenu = moment(`${moment(this.order.orderDate).format('yyyy-MM-DD')} ${this.order.orderTime}`);
          this.menuList.forEach(element => {
            element.storeMenuCategories = element.storeMenuCategories.filter(t => this.validateAvailability(t, this.order._deliveryType));
            //console.log(moment(element.deployDate).format("yyyy-MM-DD hh:mm"));
            if( moment(element.deployDate) <= timeMenu ){ //moment(this.order.orderDate).format("yyyy-MM-DD") && moment(element.deployDate).format("hh:mm") <= this.order.orderTime){
              if(this.menu == null || moment(this.menu.deployDate) <= moment(element.deployDate)){
                //console.log(this.menu);
                this.menu = element;
                console.log(this.menu);
              }
            }
          });

          if(!this.order.orderDate && !this.order.orderTime){

            this.menu = this.menuList[0];
            console.log(this.menu);
          }
          //this.menu = //this.menuList.find(t => moment(t.deployDate).format("yyyy-MM-DD") <=  moment(this.order.orderDate).format("yyyy-MM-DD") && moment(t.deployDate).format("hh:mm") <= this.order.orderTime);
          if(this.menu != null){
            this.loadOverlayMenu(this.menu);
            this.storeClosed = false;
          }else{
            this.getMenu(storeId);
            this.storeClosed = false;
          }
          //this.menu = menu[0];
        });

       // return menuList;
    }

    async getMenu(storeId: string, itemId = null, firstrun: boolean = false) { 

      // we'll check 2 things here, 1 if the store is the same, 2 if its the same menu ID
      
      //if(this.LastStoreMenuCollected.find(id => id == storeId)) {
        // if it finds something, we already had it
        // essentially do nothing here

        //console.log(this.menu);
      //} else {

        if(!firstrun) {
          //console.log("loader");

          const loader = await this.loaderService.create();
          this.storeService.getMenu(storeId, this.order.orderDate, this.order.orderTime, this.order._deliveryType)
            .pipe(finalize(async () => {
              await loader.dismiss();
            }))
            .subscribe((menu: IStoreMenu) => {

              if(this.menu?.id == menu.id) {
                // this means it already loaded that menu
                this.LastStoreMenuCollected.push(storeId);

                //console.log(this.menu);
              } else {

                this.twoForOneCats = [];
                menu.storeMenuCategories.map(storeMenuCategory => {
                  if(storeMenuCategory.isTwoForOneDeal){
                    this.twoForOneCats.push(storeMenuCategory);
                  }
                });

                menu.storeMenuCategories = menu.storeMenuCategories.filter(t => this.validateAvailability(t, this.order._deliveryType));
                this.setMenuImages(menu);
                this.menu = menu;
                //console.log(this.menu);

                this.LastStoreMenuCollected = []; // reset the cached data
                this.LastStoreMenuCollected.push(storeId); // this only checks to see what's the last store we collected the menu for and add all the stores using the same menu

                this.itemColors = [];
                this.itemSize = [];
                this.itemCategories = [];
                this.itemSubCategories = [];
                this.itemBrands = [];
                let arrCat = [],arrSub = [],arrDep = [],arrColors = [],arrSizes = [],arrBrands = [],arrBrands2 = [];
                if(this.menu.storeMenuCategories)
                {
                  this.menu.storeMenuCategories.map(storeMenu => {

                    storeMenu.storeMenuCategoryItems.map(item => {
                    
            
                      arrColors = arrColors.concat(item.item.itemColors);
                      arrSizes = arrSizes.concat(item.item.itemSizes);
                      arrDep = arrDep.concat(item.item.itemDepartments);
                      arrCat = arrCat.concat(item.item.itemCategories);
                      arrSub = arrSub.concat(item.item.itemSubCategories);
                      if(item.item.itemBrandId)
                      {
                        arrBrands2 = arrBrands2.concat(item.item.itemBrandId);
                      }
                      item.subItems.map(subItem=>{
                        arrColors = arrColors.concat(subItem.itemColors);
                        arrSizes = arrSizes.concat(subItem.itemSizes);
                        arrDep = arrDep.concat(subItem.itemDepartments);
                        arrCat = arrCat.concat(subItem.itemCategories);
                        arrSub = arrSub.concat(subItem.itemSubCategories);
                      })
                    })
                  
                })
              
                }
                let uniqueBrandsId = this.getUniqueBrands(arrBrands2);
                uniqueBrandsId.map(id => {
                  this.itemBrands.push(this.itemBrandService.itemBrands.find(brand => brand.id == id))
                })
                this.itemColors = this.getUniqueStrings(arrColors);
                this.itemSize = this.getUniqueStrings(arrSizes);
                this.menuDepartments = this.getUniqueValues(arrDep);
                this.itemCategories = this.getUniqueValues(arrCat);
                this.itemSubCategories = this.getUniqueValues(arrSub);
                this.showTimeSelector = false;
                this.menuFullImages();

                
              }
            });
        } else {
          console.log("no loader");
          this.storeService.getMenu(storeId, this.order.orderDate, this.order.orderTime, this.order._deliveryType)
            .pipe(finalize(async () => {
            })
            )
            .subscribe((menu: IStoreMenu) => {

              if(this.menu?.id == menu.id) {
                // this means it already loaded that menu
                this.LastStoreMenuCollected.push(storeId);

                console.log(this.menu);
              } else {

                this.twoForOneCats = [];
                menu.storeMenuCategories.map(storeMenuCategory => {
                  if(storeMenuCategory.isTwoForOneDeal){
                    this.twoForOneCats.push(storeMenuCategory);
                  }
                });

                menu.storeMenuCategories = menu.storeMenuCategories.filter(t => this.validateAvailability(t, this.order._deliveryType));
                this.setMenuImages(menu);
                this.menu = menu;
                console.log(this.menu);

                this.LastStoreMenuCollected = []; // reset the cached data
                this.LastStoreMenuCollected.push(storeId); // this only checks to see what's the last store we collected the menu for and add all the stores using the same menu

                this.itemColors = [];
                this.itemSize = [];
                this.itemCategories = [];
                this.itemSubCategories = [];
                this.itemBrands = [];
                let arrCat = [],arrSub = [],arrDep = [],arrColors = [],arrSizes = [],arrBrands = [],arrBrands2 = [];
                if(this.menu.storeMenuCategories)
                {
                  this.menu.storeMenuCategories.map(storeMenu => {

                    storeMenu.storeMenuCategoryItems.map(item => {
                    
            
                      arrColors = arrColors.concat(item.item.itemColors);
                      arrSizes = arrSizes.concat(item.item.itemSizes);
                      arrDep = arrDep.concat(item.item.itemDepartments);
                      arrCat = arrCat.concat(item.item.itemCategories);
                      arrSub = arrSub.concat(item.item.itemSubCategories);
                      if(item.item.itemBrandId)
                      {
                        arrBrands2 = arrBrands2.concat(item.item.itemBrandId);
                      }
                      item.subItems.map(subItem=>{
                        arrColors = arrColors.concat(subItem.itemColors);
                        arrSizes = arrSizes.concat(subItem.itemSizes);
                        arrDep = arrDep.concat(subItem.itemDepartments);
                        arrCat = arrCat.concat(subItem.itemCategories);
                        arrSub = arrSub.concat(subItem.itemSubCategories);
                      })
                    })
                  
                })
              
                }
                let uniqueBrandsId = this.getUniqueBrands(arrBrands2);
                uniqueBrandsId.map(id => {
                  this.itemBrands.push(this.itemBrandService.itemBrands.find(brand => brand.id == id))
                })
                this.itemColors = this.getUniqueStrings(arrColors);
                this.itemSize = this.getUniqueStrings(arrSizes);
                this.menuDepartments = this.getUniqueValues(arrDep);
                this.itemCategories = this.getUniqueValues(arrCat);
                this.itemSubCategories = this.getUniqueValues(arrSub);
                this.showTimeSelector = false;
                this.menuFullImages();
              }
            });
        }
        
      //}
      
    }

    getUniqueBrands(arr)
    {
      let result = [];
      for(let i = 0; i < arr.length; i++)
      {
        for(let j = 0; j < arr.length; j++)
        {
          if(arr[i] != null)
          {
            if(!result.includes(arr[i]))
          {
            result.push(arr[i]);
          }
          }
      
        }
      }
      return result;
    }


    getUniqueStrings(array)
    {
      let arr=[];
      let result=[];

      for(let i=0;i<array.length;i++)
      {
        for(let j=0;j<array.length;j++)
        {    
          if(array[i].name.translations[localStorage['lang']])
          {
            if(!arr.includes(array[i].name.translations[localStorage['lang']].toLowerCase()))
            {
              arr.push(array[i].name.translations[localStorage['lang']].toLowerCase());
              result=result.concat(array[i]);
            }
          }
        }
      }
      return result;
    }
    //This method is to get the unique categories 
    getUniqueValues(arr)
    {
      let arrId=[];
      let result=[];
     // arrId.push(arr[0].id);
      for(let i=0;i<arr.length;i++)
      {
        for(let j=0;j<arr.length;j++)
        {
            if(!arrId.includes(arr[i].id))
            {
              arrId.push(arr[i].id);
              result=result.concat(arr[i]);
            }
          }
        }
      return result;
    }
    

    private getFollowingTimes(startTime: any, endTime: any) {
      //console.log("getting following times");

      this.followingTime = [];
      // endTime = endTime.minute(0);
      // var startTime = moment().add('m', 15 - moment().minute() % 15);
      var totalTime = this.store.orderPrepareTimeMax;
      //console.log(totalTime);

      var sameDayTime = moment().add(totalTime,'minutes');
      //console.log(sameDayTime);

      if (null == this.order.orderDate && !this.store._disabled) {
         //Always add the ASAP option firts if current day only
        this.followingTime.push({
          key: null,
          value: this.translationService.translate('General.ASAP')
        });
      }   

      if (startTime > endTime) {
        endTime.add(1, "days");
      }

      var store_tz_offset = moment.tz.zone(this.store.timeZoneInfos.timeZoneId).utcOffset(new Date().getTime()); 
      //console.log(store_tz_offset);

      var client_tz_offset = moment.tz.zone(moment.tz.guess()).utcOffset(new Date().getTime());
      //console.log(client_tz_offset);

      var timeDiff = (store_tz_offset - client_tz_offset) / 60;
      //console.log(timeDiff);
   
      startTime.add(timeDiff, 'hour');
      sameDayTime.add(timeDiff, 'hour');
      // endTime.add(timeDiff, 'hour') verify this too

      //console.log(startTime);
      //console.log(sameDayTime);

      let i = 0;  
      while(startTime <= endTime){


        if(this.sameDay && moment(sameDayTime).isAfter(endTime)) //Do test it before push
        {
          this.followingDays.shift(); 
          this.followingTime.length = 0;
          break;
        }

        let newDateKey = moment(startTime).format("HH:mm");
        let newDateLabel = moment(startTime).format("HH:mm");
      

        if(this.sameDay && i >= 0)
        {
            if(moment(startTime).isAfter(sameDayTime))
            {
              newDateKey = moment(startTime).format("HH:mm");
              newDateLabel = moment(startTime).format("HH:mm");
              this.followingTime.push({
                key: newDateKey,
                value: newDateLabel
              });
            }
        }

        if(!this.sameDay)
        {
          this.followingTime.push({
            key: newDateKey,
            value: newDateLabel
          });
        }

        startTime.add('m', 15);
        i++;

        
      }
      //console.log(startTime);

    }

    private getPrepareFollowingTimes(startTime: any, endTime: any, orderDate: string) {
      this.prepareFollowingTime = [];
      var totalTime = this.store.orderPrepareTimeMax;
      var sameDayTime = moment().add(totalTime,'minutes');

      if (null == orderDate && !this.store._disabled) {
         //Always add the ASAP option first if current day only
        this.prepareFollowingTime.push({
          key: null,
          value: this.translationService.translate('General.ASAP')
        });
      }   

      if (startTime > endTime) {
        endTime.add(1, "days");
      }

      var store_tz_offset = moment.tz.zone(this.store.timeZoneInfos.timeZoneId).utcOffset(new Date().getTime()); 
      var client_tz_offset = moment.tz.zone(moment.tz.guess()).utcOffset(new Date().getTime());
      var timeDiff = (store_tz_offset - client_tz_offset) / 60;

      startTime.add(timeDiff, 'hour');
      sameDayTime.add(timeDiff, 'hour');;

      let i = 0;  
      while(startTime <= endTime){
        if(this.prepareSameDay && moment(sameDayTime).isAfter(endTime)) 
        {
          this.prepareFollowingDays.shift(); 
          this.prepareFollowingTime.length = 0;
          break;
        }

        let newDateKey = moment(startTime).format("HH:mm");
        let newDateLabel = moment(startTime).format("HH:mm");
      

        if(this.prepareSameDay && i >= 0)
        {
            if(moment(startTime).isAfter(sameDayTime))
            {
              newDateKey = moment(startTime).format("HH:mm");
              newDateLabel = moment(startTime).format("HH:mm");
              this.prepareFollowingTime.push({
                key: newDateKey,
                value: newDateLabel
              });
            }
        }

        if(!this.prepareSameDay)
        {
          this.prepareFollowingTime.push({
            key: newDateKey,
            value: newDateLabel
          });
        }

        startTime.add('m', 15);
        i++;
      }
    }

    datePickerChanged(ordertype : string) {
      //console.log("date picker change selected");
      console.log("datepicker change");

      this.storeClosed = false;
      this.menu = null;
      this.followingTime = [];
  
      if (this.dateAutoChanged) {
        this.dateAutoChanged = false;
      } else {
        this.order.orderTime = null;
      }

      var date = moment().format("YYYY-MM-DD");
      if (null != this.order.orderDate) {
        date = this.order.orderDate;
      }

      let hours: IHours = this.storeService.getStoreOpenHoursForDay(this.store, date);
  
      if (hours == null) {
        //Not opened on that day
        this.storeClosed = true;
        this.menu = null;

        return;
      }
  
      if (moment(date).isSame(moment(), 'day')) {
        //if the order is today, it is the time left until store close
        var momentDate = moment(this.store._closedHour, 'HH:mm:A');
        //If midnight, we have to tell the next day
        if (this.store._closedHour == "12:00am") {
          momentDate.add(1, "day");
        }
        var value = moment(date).hour(momentDate.diff(moment(date).startOf('day'), 'hour'));

        if (this.store._disabled) {
          
          this.getFollowingTimes(moment( date + ' ' + hours.openHours, 'YYYY-MM-DD HH:mm:A'), value);
        } else {
          this.sameDay = true;
          this.getFollowingTimes(moment().add(15 - moment().minute() % 15, 'm'), value);
      
        }
       
      } else {

        this.sameDay = false;
        //If the order is not today, gotta check what is the start time of the hour on that day to start a that moment
        //
        let militaryTimeFormat = moment(date + ' ' + hours.closeHours,"YYYY-MM-DD h:mm:ss A").format("YYYY-MM-DD HH:mm:ss");
        //
        var momentDate = moment(date + ' ' + hours.closeHours, 'YYYY-MM-DD HH:mm:A');    
        var format = 'YYYY-MM-DD HH:mm'
        var store_tz_offset = moment.tz.zone(this.store.timeZoneInfos.timeZoneId).utcOffset(new Date().getTime()); 
        var client_tz_offset = moment.tz.zone(moment.tz.guess()).utcOffset(new Date().getTime());
    
        var timeDiff = (store_tz_offset - client_tz_offset) / 60
        //
        let beforeTime = moment(date + ' ' + hours.openHours, format).add(timeDiff, 'hour');
        //
        momentDate = moment(militaryTimeFormat).add(timeDiff, 'hour');
        //momentDate = moment(date + ' ' + hours.closeHours, format).add(timeDiff, 'hour');

        //If the time is past midnight, add a day to the selected day 
        //
        let orderCloseTimeMoment = moment(hours.closeHours, 'hh:mm');
        // beforeTime = moment("00:00", 'hh:mm');
        // let limitTime = moment("04:00", 'hh:mm');
        //When the orderTime is between midnight and 4AM, we consider it the closing time and add 1 day to the selected date
        /* if (orderCloseTimeMoment.isBetween(beforeTime, limitTime, undefined, '[]')) {         
              momentDate.add(1, 'day');            
        }*/

        //
        var value = moment(date + ' ' + hours.openHours, 'YYYY-MM-DD HH:mm:A').hour(momentDate.diff(moment(date).startOf('day'), 'hour'));
        //
        this.getFollowingTimes(moment(date + ' ' + hours.openHours, 'YYYY-MM-DD HH:mm:A'), value.add(-15, 'm'));
      }

      let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      let d = moment(date);
      let dayName = days[d.day()];
      let tempFollowingTime = []
      
      //console.log(this.store);
      this.store.openHours.forEach(t => {

        if (t.days & EOpenHoursDay[dayName]) {
         
          for(let time of this.followingTime){

            let isBetween = false; 
            for(let element of t.rangeHours){
              let openHours = moment(element.openHours, "HH:mm:A");
              let updatedOpenHours = openHours.add(this.store.orderPrepareTimeMax, 'minutes');
              let updatedTime = updatedOpenHours.format("h:mma");
              if (
                moment(time.key, "HH:mm").isBetween( moment(updatedTime, "HH:mm:A"), moment(element.closeHours, "HH:mm:A")) ||
                moment(time.key, "HH:mm").isSame( moment(updatedTime, "HH:mm:A")) || moment(time.key, "HH:mm").isSame(moment(element.closeHours, "HH:mm:A"))
              ) {
                
                if (element.allowDelivery && ordertype == "delivery") {
                  isBetween = true;
                  break;
                } else if (element.allowPickup && ordertype == "pickup") {
                  isBetween = true;
                  break;
                }
              }
            }
            
            if(isBetween){
              //console.log(time);
              tempFollowingTime.push(time);
            }
         
            
          }

        }
    
      });

      //console.log(tempFollowingTime);
      this.followingTime = tempFollowingTime;
    }
    //push ends

    // datePickerChanged v2 for ItemPreparationModal popup 
    preparationDatePickerChanged(ordertype : string, orderDate: string) {
      this.prepareFollowingTime = [];

      var date = moment().format("YYYY-MM-DD");
      if (null != orderDate) {
        date = orderDate;
      }
      let followingDay = this.prepareFollowingDays.find(t => t.key == orderDate);
      let hours = followingDay.openHour;
  
      if (hours == null) {
        //Not opened on that day
        return;
      }
  
      if (moment(date).isSame(moment(), 'day')) {
        //if the order is today, it is the time left until store close
        var momentDate = moment(this.store._closedHour, 'HH:mm:A');
        //If midnight, we have to tell the next day
        if (this.store._closedHour == "12:00am") {
          momentDate.add(1, "day");
        }
        var value = moment(date).hour(momentDate.diff(moment(date).startOf('day'), 'hour'));

        if (this.store._disabled) {
          
          this.getPrepareFollowingTimes(moment( date + ' ' + hours.openHours, 'YYYY-MM-DD HH:mm:A'), value, orderDate);
        } else {
          this.prepareSameDay = true;
          this.getPrepareFollowingTimes(moment().add(15 - moment().minute() % 15, 'm'), value, orderDate);
        }
      } else {
        this.prepareSameDay = false;
        //If the order is not today, gotta check what is the start time of the hour on that day to start a that moment
        //
        let militaryTimeFormat = moment(date + ' ' + hours.closeHours,"YYYY-MM-DD h:mm:ss A").format("YYYY-MM-DD HH:mm:ss");
        //
        var momentDate = moment(date + ' ' + hours.closeHours, 'YYYY-MM-DD HH:mm:A');    
        var format = 'YYYY-MM-DD HH:mm'
        var store_tz_offset = moment.tz.zone(this.store.timeZoneInfos.timeZoneId).utcOffset(new Date().getTime()); 
        var client_tz_offset = moment.tz.zone(moment.tz.guess()).utcOffset(new Date().getTime());
    
        var timeDiff = (store_tz_offset - client_tz_offset) / 60
        //
        let beforeTime = moment(date + ' ' + hours.openHours, format).add(timeDiff, 'hour');
        //
        momentDate = moment(militaryTimeFormat).add(timeDiff, 'hour');
        //
        var value = moment(date + ' ' + hours.openHours, 'YYYY-MM-DD HH:mm:A').hour(momentDate.diff(moment(date).startOf('day'), 'hour'));
        //
        this.getPrepareFollowingTimes(moment(date + ' ' + hours.openHours, 'YYYY-MM-DD HH:mm:A'), value.add(-15, 'm'), orderDate);
      }

      let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      let d = moment(date);
      let dayName = days[d.day()];
      let tempFollowingTime = []
      
      //console.log(this.store);
      this.store.openHours.forEach(t => {

        if (t.days & EOpenHoursDay[dayName]) {
         
          for(let time of this.prepareFollowingTime){

            let isBetween = false; 
            for(let element of t.rangeHours){
              /*let openHours = moment(element.openHours, "HH:mm:A");
              let updatedOpenHours = openHours.add(this.store.orderPrepareTimeMax, 'minutes');
              
              if(orderDate == null){  
                updatedOpenHours = moment(hours.openHours, "HH:mm:A");
              }

              let updatedTime = updatedOpenHours.format("h:mma");
              if (
                moment(time.key, "HH:mm").isBetween( moment(updatedTime, "HH:mm:A"), moment(element.closeHours, "HH:mm:A")) ||
                moment(time.key, "HH:mm").isSame( moment(updatedTime, "HH:mm:A")) || moment(time.key, "HH:mm").isSame(moment(element.closeHours, "HH:mm:A"))
              ) {
                
                if (element.allowDelivery && ordertype == "delivery") {
                  isBetween = true;
                  break;
                } else if (element.allowPickup && ordertype == "pickup") {
                  isBetween = true;
                  break;
                }
              }*/
              const slotTime = moment(
                time.key,
                "HH:mm"
              );

              // Range's normal opening time
              const rangeOpenTime = moment(
                element.openHours,
                ["h:mma", "h:mm A", "HH:mm"]
              );

              // Existing store-level preparation time
              rangeOpenTime.add(
                this.store.orderPrepareTimeMax,
                "minutes"
              );

              // Earliest time calculated from the item's
              // prepareDays + prepareTime
              const itemOpenTime = moment(
                hours.openHours,
                ["h:mma", "h:mm A", "HH:mm"]
              );

              // We must respect BOTH restrictions.
              const effectiveOpenTime = moment.max(
                rangeOpenTime,
                itemOpenTime
              );

              const rangeCloseTime = moment(
                element.closeHours,
                ["h:mma", "h:mm A", "HH:mm"]
              );

              if (
                slotTime.isBetween(
                  effectiveOpenTime,
                  rangeCloseTime,
                  undefined,
                  "[]"
                )
              ) {
                if (element.allowDelivery && ordertype == "delivery") {
                  isBetween = true;
                  break;
                } else if (element.allowPickup && ordertype == "pickup") {
                  isBetween = true;
                  break;
                }
              }
            }
            
            if(isBetween){
              //console.log(time);
              tempFollowingTime.push(time);
            }
         
            
          }

        }
    
      });

      //console.log(tempFollowingTime);
      this.prepareFollowingTime = tempFollowingTime;
    }



    setMenuImages(menu: IStoreMenu) {
      for (let category of menu.storeMenuCategories) {
       
        for (let item of category.storeMenuCategoryItems) {
          this.fetchItemImage(item.item);
          item.subItems.forEach(t => {
            this.fetchItemImage(t);
          });        
        }
      }
    }

    showPrice(item: IStoreMenuCategoryItem) {
      let show = true;
      for (let optionCategory of item.item.itemOptionCategories) {
        if (optionCategory.overrideDefaultPrice) {
          show = false;
        }
      }
  
      return show;
    }

    async proceedGuest() {
      if (this.settingService.configuration.hideMemberProgram) {
        this.checkout();
        return;
      }

      const modal = await ProceedAsGuestModalComponent.open(this.modalController);
      modal.onWillDismiss()
        .then((result) => {
          if (result.data.cancelCart) {
     
            return;
          } 

          this.checkout();
        });
    }


    async submit(orderType: OrderType, fromDesktop: boolean = false) {
      this.order._deliveryType = orderType;
      //third condition mean a time has already been picked for today
      if((this.store._status == "General.Open" && !(this.order.orderDate != null && this.order.orderTime == null)) || (this.order.orderTime != null && this.order.orderDate != null) || (this.order.orderTime != null && this.order.orderDate == null)){
        await this.modalController.dismiss(true);        
      }
      else{
        localStorage.removeItem('editKey');
        await this.modalController.dismiss();
        this.modalController.create({
          component: ClosedModalComponent,
          componentProps: {
            orderType: this.order._deliveryType, 
            fromDesktop: fromDesktop    
          },
        }).then(m => {
          m.present();
        })
     
      }
    }


    async cart(comesFromClosedStore: boolean = false, fromDesktop: boolean = false) { 
      if (comesFromClosedStore) {
        if (!this.authService.isAuthenticated) {
          this.proceedGuest();
          await this.modalController.dismiss();
          return;
        }
        await this.modalController.dismiss();
        this.checkout();
        return;
      }

      // this adds a the saved store into the order if it doesn't have any
      if(!this.order.store && this.store){
        this.order.store = this.store;
      }

      // this is when we brought the item from a store ( no refresh)
      if(this.store.id != localStorage.getItem('StoreId')){
        
        this.loaderService.create().then(result => {

          this.storeService.getStore(localStorage.getItem('StoreId'))
          .pipe(
            finalize(() => {
            result.dismiss();
           }))
          .subscribe(
            async store => { 
              this.order.store = store;

              const modal = await this.modalController.create({
                component: CartModalComponent,
                componentProps: {
                  order: this.order,
                  store: store,
                  menu:  this.menu,
                  orderType: this.order._deliveryType,
                  fromDesktop: fromDesktop,
                  checkTwoForOneDiscounts: this.checkTwoForOneDiscounts.bind(this)
              }
            // cssClass: this.order._deliveryType ?  '':'checkout-modal'
            });
    
            modal.onWillDismiss()
            .then(async (result) => {
              //here you ll insert the logic 
              //We are very very close just follow from here 

              console.log(result);
              if (!result.data) {
                return;
              }
              console.log(result);
                
              if(result?.data?.fullItemEdit) {
                /*
                if(result?.data) {
                  if(result.data?.item) {
                    if(result.data.item.item.skipAllergies) {
                      this.currentItem = result.data.orderItem;
                      this.configureItemOptions(result.data.item, result.data.optionIndex, true)
                    } else {
                      this.currentItem = result.data.orderItem;
                      await this.itemRequestModal(result.data.item,result.data.optionIndex)
                    }
                    return;
                  } 
                }
                */

                return;
              } else {
                if(result?.data) {
                  if(result.data?.item) {
                    if(result.data.item.item.skipAllergies) {
                      this.currentItem = result.data.orderItem;
                      this.configureItemOptions(result.data.item, result.data.optionIndex, true)
                    } else {
                      this.currentItem = result.data.orderItem;
                      await this.itemRequestModal(result.data.item,result.data.optionIndex)
                    }
                    return;
                  } 
                }
              }
              
              
              
  
              if(fromDesktop){
                this.desktopCart(1);
                return;
              }
              
              if (!this.authService.isAuthenticated) {
                this.proceedGuest();
                return;
              }
              this.checkout();
            });
        
            await modal.present();
          });
        }); 
      } else {

        const modal = await this.modalController.create({
          component: CartModalComponent,
          componentProps: {
            order: this.order,
            store: this.store,
            menu:  this.menu,
            orderType: this.order._deliveryType,
            fromDesktop: fromDesktop,
            checkTwoForOneDiscounts: this.checkTwoForOneDiscounts.bind(this)
          }
         // cssClass: this.order._deliveryType ?  '':'checkout-modal'
        });
        modal.onWillDismiss()
          .then(async (result) => {
            
            //here you ll insert the logic 
            //We are very very close just follow from here 
            if (!result.data) {
              return;
            }

            if (!result.data) {
              return;
            }
            console.log(result);
              
            if(result?.data?.fullItemEdit) {
              if(result.data) {
                if(result.data?.item){
                  // this is where we go for the item menu
                  
                  var item = result.data.orderItem._parentItem;

                  let isTwoForOne = this.isTwoForOneItem(item.item);

                  const dismissItemModal = (cancel: boolean, itemDetailCombination: itemDetailCombination, quantity: number,
                    item: IStoreMenuCategoryItem, combinationPrice: number, cartOrderType: OrderType) => {
                    modalAllinOne.dismiss({
                      cancel: cancel,
                      itemDetailCombination: itemDetailCombination,
                      quantity: quantity,
                      item: item,
                      combinationPrice: combinationPrice,
                      orderType: cartOrderType
                    });
                  };

                  this.currentItem = {
                    itemId: item.item.id,
                    itemName: item.item.itemName,
                    itemNumber: item.item.itemNumber,
                    options: [],
                    taxEligible: item.item.taxEligible,
                    price: item.item.price,
                    quantity: 1,
                    allergies: "",
                    note: "",
                    _hidePrice: false,
                    _chainItemId: null,
                    itemDetailCombination: null,
                    itemAvailableHour: item.item.itemAvailableHour,
                    isDelivery: item.item.isDelivery,
                    orderType: result.data.orderItem.orderType,
                    isAlcohol: item.item.isAlcohol,
                    _originalPrice: item.item.price,
                    _isTwoForOne: isTwoForOne,

                    isFoodItem: item.item.isFoodItem,
                    _relatedStoreId: this.trackStoreId
                  };

                  const modalAllinOne = await this.modalController.create({
                    component: MenuItemAllinoneModalComponent,
                    componentProps: {
                      item: item,
                      trackStoreId: this.trackStoreId,
                      store: this.store,
                      orderType: result.data.orderItem.orderType,
                      chosenQuantity: null,
                      chosenItemDetailCombination: null,
                      dismissItemModal: dismissItemModal,

                      // these are to process the rest of the items including options
                      orderItem: this.currentItem,
                      order: this.order,
                      orderItemEditing: result.data.orderItem
                    },
                    // manually set cssClass for now
                    cssClass: "menu-item-allinone-modal"
                  });


                  modalAllinOne.onWillDismiss()
                  .then((allinoneResult) => {

                    console.log(allinoneResult.data);
                    console.log(allinoneResult.data.selectedSubItem);

                    this.buynow = allinoneResult.data.buynow;

                    var NewItem = allinoneResult.data.selectedSubItem;
          
                    ////////////////////////////////////////////////////////////////////////////////////////////////////////
                    if(allinoneResult.data.selectedSubItem) {
                      if (NewItem.externalPOSId != null) {

                        let count: number = 1;

                        this.order.orderItems.forEach(itemLoop => {
                          if (item.itemId == itemLoop.itemId) {
                            count += itemLoop.quantity;
                          }
                        });

                        this.itemService.validateThirdPartyQuantities(this.store.id, NewItem.externalPOSId, count).subscribe(success => {
                          if (!success) {
                              NewItem.isActive = false;
                              this.notAvailable(this.translationService.translate('Item.InventoryWarningHeader'), this.translationService.translate('Item.InventoryWarningContent'))
                              return;
                              console.log("not enough quantities");
                          }

                        });

                        if(!NewItem.isActive || (NewItem.quantity === 0 && NewItem.isInventoryActive && NewItem.isInventoryExist)) {
                          return;
                        }
                      }
                    }

                    if(allinoneResult.data.selectedSubItem) { 

                    } else {
                      item.item.itemOptionCategories.forEach(optionCategory => {
                        optionCategory.options.forEach((option: any) => {
                          option.option.quantity = 0;
                          if(optionCategory.chainItem){
                            option.chainItemOptionCategories.forEach(chainItemOptionCategory => {
                              chainItemOptionCategory.options.forEach((chainItemOption: IStoreMenuItemOption) => {
                                chainItemOption.option.quantity = 0;
                                chainItemOption.option._selected = false;
                              });
                            })
                          }
                        });
                      });
                    }

                    
                    
                    if(allinoneResult.data == undefined || allinoneResult.data == null) {
                      localStorage.removeItem('editKey')
                      return
                    }

                    if(allinoneResult.data.orderType) {
                      this.orderType = allinoneResult.data.orderType
                    }

                    if(allinoneResult.data.emptyCart) {
                      this.order.orderItems = []
                    }

                    if(allinoneResult.data) {
                      // will always be null for now
                      if(allinoneResult.data.itemDetailCombination) {
                        this.itemDetailCombination = allinoneResult.data.itemDetailCombination
                        //this.quantity=1;
                        this.retailQuantity = allinoneResult.data.quantity;
                        this.combinationPrice = allinoneResult.data.combinationPrice;

                        // add measurements to itemdetailcombination
                        for(let combinations of allinoneResult.data.item.item.itemDetailCombination){
                          if(combinations.code === allinoneResult.data.itemDetailCombination.code){
                            for(let measurements of allinoneResult.data.item.item.itemMeasurements){
                              if(measurements.id === combinations.measurementsId){
                                this.itemDetailCombination.measurementsId = measurements.id;
                                this.itemDetailCombination.measurements = measurements.measurements;
                              }
                            }
                          }
                        }
                      } else {
                        this.combinationPrice = null;
                        this.itemDetailCombination = null;
                        this.retailQuantity = null;
                      }

                      if(allinoneResult.data.selectedSubItem) {
                        if(allinoneResult.data.selectedSubItem.itemAvailableHour) {
                          this.itemAvailableHour = allinoneResult.data.selectedSubItem.itemAvailableHour;
                        }
                      } else {
                        if(allinoneResult.data.item) {
                          if(allinoneResult.data.item.item.itemAvailableHour) {
                            this.itemAvailableHour = allinoneResult.data.item.item.itemAvailableHour;
                          }
                        } else {
                          this.itemAvailableHour = null;
                        }
                      }
                    }
                    
                    if(allinoneResult.data) {
                      if(allinoneResult.data.cancel) {
                        return;
                      }
                    }

                    if(allinoneResult.data.selectedSubItem) {
                      NewItem.itemOptionCategories.forEach(optionCategory => {
                        optionCategory.options.forEach((option: any) => {
                          if(option.option.quantity > 0) {

                          } else {
                            option.option.quantity = 0;
                            if(optionCategory.chainItem){
                              option.chainItemOptionCategories.forEach(chainItemOptionCategory => {
                                chainItemOptionCategory.options.forEach((chainItemOption: IStoreMenuItemOption) => {
                                  chainItemOption.option.quantity = 0;
                                  chainItemOption.option._selected = false;
                                });
                              })
                            }
                          }
                          
                        });
                      });

                      // i might need to rebuild the item:
                      var itemDerived: IStoreMenuCategoryItem = {
                        itemId: NewItem.id,
                        item: NewItem,
                        parentItem: item
                      }

                      ///////////////////////////////////////////////////////////////////////////////
                      // this removes the item before rebuilding it
                      var orderPickupItems = this.order.orderItems.filter(item => result.data.orderItem.orderType == "pickup");

                      this.order.orderItems.splice(this.order.orderItems.findIndex(
                        item => item == orderPickupItems[result.data.index]
                      ), 1);

                      localStorage['cartStorage'] = JSON.stringify(this.order.orderItems);
                      ///////////////////////////////////////////////////////////////////////////////

                      this.addItemToCart(itemDerived, allinoneResult.data.foodQuantity, true);
                    } else {
                      // before adding to cart, delete item at the same index location
                      this.addItemToCart(item);
                    }
                  });
                  await modalAllinOne.present();
                }

                return;
              }
              

              return;
            } else {
              if(result.data) {
                if(result.data?.item){
                  if(result.data.orderItem.itemDetailCombination){
                    this.currentItem = result.data.orderItem;
                    if(result.data.optionItemIndex != null){
                      let optionNumber = result.data.item.item.itemOptionCategories[result.data.optionIndex].options.findIndex(
                        (option) => option.itemId == result.data.orderItem.options[result.data.optionItemIndex].itemId);
                      
                      await this.configureItemOptionDetail(result.data.item, result.data.optionIndex, result.data.item.item.itemOptionCategories[result.data.optionIndex].options[optionNumber].option, 
                        result.data.orderItem.options[result.data.optionItemIndex].itemDetailCombination, result.data.orderItem.options[result.data.optionItemIndex].quantity);

                      return;
                    }
                    //await this.configureItemOptions(result.data.item, result.data.optionIndex)
                    this.itemDetail(result.data.item, this.currentItem.itemDetailCombination, this.currentItem.quantity);

                    return;
                  }

                  if(result.data.item.item.skipAllergies){
                    this.currentItem = result.data.orderItem;
                    this.configureItemOptions(result.data.item, result.data.optionIndex, true)
                  } else {
                    this.currentItem=result.data.orderItem;
                    await this.itemRequestModal(result.data.item,result.data.optionIndex)
                  }

                  return;
                }
              }
            }

            
              
  
            if(fromDesktop){
              this.desktopCart(1);
              return;
            }
            
            if (!this.authService.isAuthenticated) {
              this.proceedGuest();
              return;
            }
            this.checkout();
          });
    
        await modal.present();
      }

          
    }
    
    async desktopCart(numOfCarts: number) { 
      
      if(numOfCarts > 1){
        this.cart(false, true);
        return;
      }

      if(!((this.store._status == "General.Open" && !(this.order.orderDate != null && this.order.orderTime == null)) || (this.order.orderTime != null && this.order.orderDate != null) || (this.order.orderTime != null && this.order.orderDate == null))){
        this.cart(false, true);
        return;
      }

      let numOfOrderTypes = [];
      this.order.orderItems.forEach(item => {
        if(!numOfOrderTypes.includes(item.orderType)){
          numOfOrderTypes.push(item.orderType);
        }
      });
      if(numOfOrderTypes.length == 1){
        this.order._deliveryType = this.order.orderItems[0]?.orderType;
      }
  
      // this adds a the saved store into the order if it doesn't have any
      if(!this.order.store && this.store){
        this.order.store = this.store;
      }

      if (this.store.id != localStorage.getItem("StoreId")) {
        this.loaderService.create().then((result) => {
          this.storeService
            .getStore(localStorage.getItem("StoreId"))
            .pipe(
              finalize(() => {
                result.dismiss();
              })
            )
            .subscribe(async (store) => {
              this.order.store = store;
              const modal = await this.modalController.create({
                component: DesktopCheckout,
                cssClass: "full-modal",
                componentProps: {
                  order: this.order,
                  store: store,
                  checkTwoForOneDiscounts: this.checkTwoForOneDiscounts.bind(this)
                },
                // cssClass: this.order._deliveryType ?  '':'checkout-modal'
              });

              modal.onWillDismiss()
              .then(async (result) => {
                if (!result.data) {
                  return;
                }

                if(result.data) {
                  if(result.data.item)
                  {
                    if(result.data.item.item.skipAllergies){
                      this.currentItem = result.data.orderItem;
                      this.configureItemOptions(result.data.item, result.data.optionIndex, true)
                    } else {
                      this.currentItem = result.data.orderItem;
                      await this.itemRequestModal(result.data.item, result.data.optionIndex)
                    }
                    return;
                  }
                }
                

                this.order = {
                    store: null,
                    orderItems: this.order.orderItems.filter(items => items.orderType != this.order._deliveryType),
                    note: "",
                    _deliveryType: this.order._deliveryType
                  };

                //if(result.data.isRebateApplied) do your stuff
                this.showReceipt(result.data);
              });
  
              await modal.present();
            });
        });
      } else {

        console.log("test");
        const modal = await this.modalController.create({
          component: DesktopCheckout,
          cssClass: "full-modal",
          componentProps: {
            order: this.order,
            store: this.store,
            checkTwoForOneDiscounts: this.checkTwoForOneDiscounts.bind(this)
          },
          // cssClass: this.order._deliveryType ?  '':'checkout-modal'
        });
        this.desktopCheckout();

        modal.onWillDismiss()
        .then(async (result) => {
          if (!result.data) {
            return;
          }
            
          if(result.data) {
            console.log(result.data);

            if(result.data.item) {
              if(result.data.item.item.skipAllergies){
                console.log("skip allergies");

                this.currentItem = result.data.orderItem;
                this.configureItemOptions(result.data.item, result.data.optionIndex, true);
              } else {
                console.log("item request modal");

                this.currentItem = result.data.orderItem;
                await this.itemRequestModal(result.data.item,result.data.optionIndex);
              }
              return;
            }

          }
          
          this.order = {
              store: null,
              orderItems: this.order.orderItems.filter(items => items.orderType != this.order._deliveryType),
              note: "",
              _deliveryType: this.order._deliveryType
            };

          //if(result.data.isRebateApplied) do your stuff
          this.showReceipt(result.data);
        });
  
        await modal.present();
      }
    }

    async orderCheckoutPromo() {
      console.log(this.store);
      if(this.store)
      {
        if(!this.store.allowDelivery && this.order._deliveryType === 'delivery') {
          this.notAvailable(this.translationService.translate('Coupon.ItemNotAvailable'), this.translationService.translate('Coupon.StoreNotAvailablePickup'))
          return;
        }

        if(!this.store.allowPickup && this.order._deliveryType === 'pickup'){
          this.notAvailable(this.translationService.translate('Coupon.ItemNotAvailable'), this.translationService.translate('Coupon.StoreNotAvailablePickup'))
          return;
        }

        let items = (JSON.parse(localStorage[CACHE_KEY]));
        this.order.orderItems = [...items];
        this.checkout();
      }
    }

    async orderCheckout()
    {    
      
      
      if(this.store)
      {
         if(!this.store.allowDelivery && this.order._deliveryType === 'delivery')
              {
                this.notAvailable(this.translationService.translate('Coupon.ItemNotAvailable'), this.translationService.translate('Coupon.StoreNotAvailablePickup'))
                return;
              }
              if(!this.store.allowPickup && this.order._deliveryType === 'pickup')
              {
                this.notAvailable(this.translationService.translate('Coupon.ItemNotAvailable'), this.translationService.translate('Coupon.StoreNotAvailablePickup'))
                return;
              }
        let items=(JSON.parse(localStorage[CACHE_KEY]));
        this.order.orderItems=[...items]
        this.checkout();
      }
 
    }

    async checkout() {
      console.log(localStorage[CACHE_KEY]);

      if(this.store.id != localStorage.getItem('StoreId')){
        this.loaderService.create().then(result=>{
          this.storeService.getStore(localStorage.getItem('StoreId'))
          .pipe(finalize(()=>{
            result.dismiss();
          }))
          .subscribe(
            
            async store => { 
              this.order.store = store;
              if(this.order._deliveryType != "table"){
                const modal = await this.modalController.create({
                  component: CheckoutModalComponent,
                  componentProps: {
                    order: this.order,
                    store: store
                  },
                  cssClass: 'fullscreen'
                });
      
                modal.onWillDismiss()
                .then((result) => {
                  if (!result.data)
                    return;
                  this.order = {
                      store: null,
                      orderItems: this.order.orderItems.filter(items => items.orderType != this.order._deliveryType),
                      note: "",
                      _deliveryType: this.order._deliveryType
                    };
      
                  //if(result.data.isRebateApplied) do your stuff
                  this.showReceipt(result.data);
                });
            
                await modal.present();
              } else {
                const modal = await this.modalController.create({
                  component: TableOrderConfirmationModalComponent,
                  componentProps: {
                    order: this.order,
                    store: store
                  }
                });
      
                modal.onWillDismiss()
                .then((result) => {
                  this.order = {
                    store: null,
                    orderItems: this.order.orderItems.filter(items => items.orderType != this.order._deliveryType),
                    note: "",
                    _deliveryType: this.order._deliveryType
                  };
                  this.router.navigate([`/stores/table-order`]);
                });

                await modal.present();
              }
          });
        });     
      } else {
        this.order.store = this.store;
        if(this.order._deliveryType != "table"){
          const modal = await this.modalController.create({
            component: CheckoutModalComponent,
            componentProps: {
              order: this.order,
              store: this.store
            },
            cssClass: 'fullscreen'
          });
      
          modal.onWillDismiss()
            .then((result) => {
              if (!result.data)
                return;
      
              this.order = {
                  store: null,
                  orderItems: this.order.orderItems.filter(items => items.orderType != this.order._deliveryType),
                  note: "",
                  _deliveryType: this.order._deliveryType
                };
    
          //if(result.data.isRebateApplied) do your stuff
              this.showReceipt(result.data);
            });
      
          await modal.present();
        }  else {
          const modal = await this.modalController.create({
            component: TableOrderConfirmationModalComponent,
            componentProps: {
              order: this.order,
              store: this.store
            }
          });

          modal.onWillDismiss()
          .then((result) => {
            this.order = {
              store: null,
              orderItems: this.order.orderItems.filter(items => items.orderType != this.order._deliveryType),
              note: "",
              _deliveryType: this.order._deliveryType
            };
            this.router.navigate([`/stores/table-order`]);
          });

          await modal.present();
        }
      }
    }

    async desktopCheckout() {
      if (this.store.id != localStorage.getItem("StoreId")) {
        this.loaderService.create().then((result) => {
          this.storeService
            .getStore(localStorage.getItem("StoreId"))
            .pipe(
              finalize(() => {
                result.dismiss();
              })
            )
            .subscribe(async (store) => {
              this.order.store = store;
            });
        });
      } else {
        this.order.store = this.store;
      }
    }
  
    async showReceipt(receipt: ICustomerTransactionEmail) {
      const modal = await this.modalController.create({
        component: ReceiptComponent,
        componentProps: {
          customerTransactionEmail: receipt,
          remainingCartItems: this.order.orderItems
        },
        cssClass: 'fullscreen'
      });
  
      modal.onWillDismiss()
        .then(() => {
          if (receipt.isShipping){
            this.router.navigate(['/shipping/tracking', receipt.orderId]);
          } else {
            this.router.navigate(['/order/tracking', receipt.orderId]);
          }
          /*if(receipt.isDelivery){
            this.router.navigate(['/order/tracking', receipt.orderId]);
          } else if (receipt.isShipping){
            this.router.navigate(['/shipping/tracking', receipt.orderId]);
          } else {
            this.router.navigate(['/stores']);
          }*/
        });
  
      await modal.present();
    }
  
    fetchItemImage(item: IStoreMenuItem) {
      if (item.itemImageShortName != null && item.itemImageShortName != "" && item._itemImage == null) {
        this.storeService.getItemImage(item.itemImageShortName).subscribe(data => {
          this.imageService.createImageFromBlob(data)
          .pipe(finalize(() => {
             
          }))
          .subscribe((buffer) => {
           
              item._itemImage =  this.sanitization.bypassSecurityTrustStyle(`url(${buffer})`);
          });       
        }, error => {
        });
      } else {
        item._itemImage =  this.sanitization.bypassSecurityTrustStyle(`url(assets/imgs/menu/not-found.png)`);
      }
    }
  
    menuFullImages() {
      //let useImageTemplate: boolean = true;
      if (this.menu != undefined) {
        let menuHasImage = false;
        this.menu.storeMenuCategories.forEach(menuCategory => {
          if (menuCategory.imageShortName && menuCategory.imageShortName.length > 0) {
              menuHasImage = true;
          }     
        });
        this.useMenuWithImages = menuHasImage;
      }
  
      //return useImageTemplate;
    }
  
    getFollowingDates(store: IStore = null) {
      let numberOfDaysToInclude = 30;
      this.followingDays = [];
      let date = moment().format();

      for (let i = 0; i < numberOfDaysToInclude; i++) {
        const currentDate = moment(date).locale(this.translationService.getLanguage()).add(i, 'days');
        const newDateKey = currentDate.format("YYYY-MM-DD");
        const newDateLabel = currentDate.format("Do MMMM");
        //let newDateKey = moment(date).locale(this.translateService.currentLang).add(i, 'days').format("YYYY-MM-DD");
        //let newDateLabel = moment(date).locale(this.translateService.currentLang).add(i, 'days').format("Do MMMM");
        
        //Check if closed and the current time is after the closed time
        if (store != null) {
          if (i == 0 && store._closedAfterClosedHours) {
            continue;
          } 
        }
        
        // here i need to add something that checks whether it's part of the store's opening hours or not

        // Get the day name
        const dayName = currentDate.format('dddd'); // Full day name
        
        // Convert to enum value
        const dayEnumValue = this.getEnumValueFromDayName(dayName);

        let isOpen = false;
        let openHourVal: IOpenHour;
        if (store?.openHours && Array.isArray(store.openHours)) {
          for (const oh of store.openHours) {
            if ((oh.days & dayEnumValue) === dayEnumValue) {
              openHourVal = oh;
              isOpen = true;
              break;
            }
          }
        }

        if (!isOpen) {
          continue; // Skip this day if store is closed
        }

        this.followingDays.push({
          key:  i == 0 ? null: newDateKey,
          value: i == 0 ? this.translationService.translate("Menu.Date.Today") : (i == 1 ? this.translationService.translate("Menu.Date.Tomorrow") : newDateLabel),
          openHour: openHourVal
        });
      }
    }  

    getEnumValueFromDayName(dayName: string): EOpenHoursDay {
      const map: { [key: string]: EOpenHoursDay } = {
        // English
        'monday': EOpenHoursDay.Monday,
        'tuesday': EOpenHoursDay.Tuesday,
        'wednesday': EOpenHoursDay.Wednesday,
        'thursday': EOpenHoursDay.Thursday,
        'friday': EOpenHoursDay.Friday,
        'saturday': EOpenHoursDay.Saturday,
        'sunday': EOpenHoursDay.Sunday,

        // French
        'lundi': EOpenHoursDay.Monday,
        'mardi': EOpenHoursDay.Tuesday,
        'mercredi': EOpenHoursDay.Wednesday,
        'jeudi': EOpenHoursDay.Thursday,
        'vendredi': EOpenHoursDay.Friday,
        'samedi': EOpenHoursDay.Saturday,
        'dimanche': EOpenHoursDay.Sunday,
      };

      return map[dayName.toLowerCase()] ?? EOpenHoursDay.None;
    }

  test: boolean = false;
  getFollowingDays(orderType): any[] {
    if(!this.test && this.followingDays.length > 0) {
      //console.log(orderType);
      //console.log(this.followingDays);
      this.test = true;
    }

    var dayReworked: any[] = [];
    for(var i = 0; i < this.followingDays.length; i++) {
      var addDay: boolean = false;
      var day = this.followingDays[i];
      if(orderType == "pickup" && day.openHour.allowPickup && !addDay) {
        for(var y = 0; y < day.openHour.rangeHours.length; y++) {
          var rangeHours = day.openHour.rangeHours[y];

          if(rangeHours.allowPickup) {
            addDay = true;
          }
        }
      } else if(orderType == "delivery" && day.openHour.allowDelivery && !addDay) {
        for(var y = 0; y < day.openHour.rangeHours.length; y++) {
          var rangeHours = day.openHour.rangeHours[y];

          if(rangeHours.allowDelivery) {
            addDay = true;
          }
        }
      }

      if(addDay) {
        dayReworked.push(day);
      }
    }

    return dayReworked;
  }

  getItem(itemId) {
    let arr = [];
    
    this.storeService.getItem(itemId).subscribe(data => {
      
      arr.push(data.item);
      this.sortedMenu = [...arr];

      if(arr.length>0) {
        setTimeout(() => {
          this.itemDetail(data);
        },500)
      }
    })
  }

  getItemAtInit(itemId) {
    let arr = [];
    
    this.storeService.getItem(itemId).subscribe(data => {
      
      arr.push(data.item);
      //this.sortedMenu=[...arr];
      if(arr.length > 0) {
        setTimeout(() => {
          this.itemDetail(data);
        }, 500)
      }
    })
  }

    //We show a category as horizontal dispaly as soon as 1 item is flagged in that category
    showCategoryInline(category: IStoreMenuCategory) {

      for (let i = 0; i < category.storeMenuCategoryItems.length; i++) {
        if (category.storeMenuCategoryItems[i].item.isHorizontalDisplay) {
          return true;
        } 
      }      

      return false;
    }



  /*
  async PreloadMenuCatAndItemImage(menu: IStoreMenu) {

    for(var i = 0; i < menu.storeMenuCategories.length; i++) {
      var menuCategory = menu.storeMenuCategories[i]

      if (menuCategory?.imageShortName) {
        const catShortName = menuCategory.imageShortName;

        // Check cache first
        const cached = this.menuImageCache.find(
          x => x.shortName === catShortName
        );

        if (cached) {
          console.log('Image served from cache:', catShortName);
          return cached.imageUrl;
        }

        // Not cached, fetch it
        const apiUrl = this.settingService.apiUrl(
          `/Menu/GetMenuItemImage?name=${catShortName}`
        );

        const blob = await firstValueFrom(
          this.http.get(apiUrl, { responseType: 'blob' })
        );

        const imageUrl = URL.createObjectURL(blob);

        this.menuImageCache.push({
          shortName: catShortName,
          imageUrl
        });

        console.log('Category Image downloaded and cached:', catShortName);
      }

      // then you get the items inside and download each of them
      for(var y = 0; y < menuCategory.storeMenuCategoryItems.length; y++) {
        var item = menuCategory.storeMenuCategoryItems[y];
        
        if (!item?.item?.itemImageShortName) {

          // default image
          const itemShortName = this.settingService.getItemPlaceHolderPath();

          // Check cache first
          const cached = this.itemImageCache.find(
            x => x.shortName === itemShortName
          );

          if (cached) {
            console.log('Image served from cache:', itemShortName);
            continue;
          }

          // Not cached, fetch it
          const apiUrl = this.settingService.apiUrl(
            `/Menu/GetMenuItemImage?name=${itemShortName}`
          );

          const blob = await firstValueFrom(
            this.http.get(apiUrl, { responseType: 'blob' })
          );

          const imageUrl = URL.createObjectURL(blob);

          this.itemImageCache.push({
            shortName: itemShortName,
            imageUrl
          });

          continue;
        } else {
          const itemShortName = item.item.itemImageShortName;

          // Check cache first
          const cached = this.itemImageCache.find(
            x => x.shortName === itemShortName
          );

          if (cached) {
            console.log('Image served from cache:', itemShortName);
            return cached.imageUrl;
          }

          // Not cached, fetch it
          const apiUrl = this.settingService.apiUrl(
            `/Menu/GetMenuItemImage?name=${itemShortName}`
          );

          const blob = await firstValueFrom(
            this.http.get(apiUrl, { responseType: 'blob' })
          );

          const imageUrl = URL.createObjectURL(blob);

          this.itemImageCache.push({
            shortName: itemShortName,
            imageUrl
          });
          
          console.log('Item Image downloaded and cached:', itemShortName);
        }
      }
    }
  }
  */

    getItemImage(item: IStoreMenuCategoryItem) {
      const itemShortName = item.item.itemImageShortName;

      // Check cache first
      const cached = this.storeService.itemImageCache.find(
        x => x.shortName === itemShortName
      );

      if (cached) {
        //return cached.imageUrl;
        return 'url(' + cached.imageUrl + ')';
      } else {
        const itemShortNameSub = this.settingService.getItemPlaceHolderPath();

        const subCached = this.storeService.itemImageCache.find(
          x => x.shortName === itemShortNameSub
        );

        if (subCached) { 
          //return subCached.imageUrl;
          return 'url(' + subCached.imageUrl + ')';
        }
      }

      /*
      if (item.item.itemImageShortName != null && item.item.itemImageShortName != "") {
        return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + item.item.itemImageShortName) + ')';
      } else {
        return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + this.settingService.getItemPlaceHolderPath()) + ')';
      }
      */
    }








    getSortedMenuImage(item)
    {
      const itemShortName = item.itemImageShortName;

      // Check cache first
      const cached = this.storeService.itemImageCache.find(
        x => x.shortName === itemShortName
      );

      if (cached) {
        //return cached.imageUrl;
        return 'url(' + cached.imageUrl + ')';
      }
      
      /*
      if (item.itemImageShortName != null && item.itemImageShortName != "") {
        return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + item.itemImageShortName) + ')';
      }
      */
    }

    getCategoryImage(menuCategory: IStoreMenuCategory) {
      const menuShortName = menuCategory.imageShortName;

      // Check cache first
      const cached = this.storeService.menuImageCache.find(
        x => x.shortName === menuShortName
      );

      if (cached) {
        //return cached.imageUrl;
        return 'url(' + cached.imageUrl + ')';
      }

      /*
      if (menuCategory.imageDisplayName != null && menuCategory.imageShortName != "" && menuCategory._image == null) {
        return 'url(' + this.settingService.apiUrl("/Menu/GetMenuItemImage?name=" + menuCategory.imageShortName) + ')';
      }
      */
     
    }

    refreshMenu() {
      this.refreshMenuSubject.next();
    }

    checkTwoForOneDiscounts(){
      if(this.order.orderItems.length < 1){
        return;
      }

      this.twoForOneCats.forEach(category => {
        if(category.storeMenuCategoryItems.length > 0){
          // get ids of all items in the category
          let categoryItemIds = category.storeMenuCategoryItems.reduce((arr, item) => {
            arr.push(item.itemId);
            item.subItems.forEach(subItem => arr.push(subItem.id));
            return arr;
          }, [] as string[]);

          // expand items
          let expandedOrderitems = this.order.orderItems.reduce<IOrderItem[]>((acc, item) => {
            for (let i = 0; i < item.quantity; i++) {
              acc.push({...item, quantity: 1, price: item._originalPrice });
            }
            return acc;
          }, []);

          expandedOrderitems = this.applyTwoForOneDiscounts(categoryItemIds, expandedOrderitems, "pickup");
          expandedOrderitems = this.applyTwoForOneDiscounts(categoryItemIds, expandedOrderitems, "delivery");
          expandedOrderitems = this.applyTwoForOneDiscounts(categoryItemIds, expandedOrderitems, "shipping");
          expandedOrderitems = this.applyTwoForOneDiscounts(categoryItemIds, expandedOrderitems, "table");

          // readd order items
          this.order.orderItems = [];
          expandedOrderitems.forEach((item) => {
            let existingItem = this.order.orderItems.find((r) => r.itemId == item.itemId && r.price == item.price && r.orderType == item.orderType);
            if (existingItem) {
              existingItem.quantity++;
            } else {
              this.order.orderItems.push({ ...item, price: item.price, quantity: 1 });
            }
          });
        }
      });
    }

    private applyTwoForOneDiscounts(categoryItemIds: string[], expandedOrderitems: IOrderItem[], orderType: OrderType): IOrderItem[] {
      let eligibleItems = expandedOrderitems.filter(item => categoryItemIds.includes(item.itemId) && item.orderType == orderType);
      let numOfDiscountedItems = Math.floor((eligibleItems.length)/2);

      if(numOfDiscountedItems > 0){
        let sortedPickupItems = eligibleItems.sort((a, b) => a._originalPrice - b._originalPrice);
        let cheapestItems = sortedPickupItems.slice(0, numOfDiscountedItems);

        let cheapestItemsIndexes = cheapestItems.map(item => expandedOrderitems.indexOf(item));
        cheapestItemsIndexes.forEach(index => {
          expandedOrderitems[index].price = 0;
          expandedOrderitems[index].isFree = true;
        });
      }

      return expandedOrderitems;
    }

    private isTwoForOneItem(item: IStoreMenuItem): boolean{
      if(!item || !this.twoForOneCats) return false;
      for(let category of this.twoForOneCats){
        if(category.storeMenuCategoryItems.some(t => t.itemId == item.id || (item.parentItemId && t.itemId == item.parentItemId))){
          this.twoForOneSelectedItem = item;
          this.twoForOneSelectedCategory = category;
          return true;
        }
      }
      this.twoForOneSelectedItem = null;
      this.twoForOneSelectedCategory = null;
      return false;
    }

    private async checkTwoForOnePopup(itemId: string, orderType: OrderType){
      if(this.twoForOneSelectedItem && this.twoForOneSelectedItem.id == itemId){
        let items = [];
        items = this.order.orderItems.filter(t => t._isTwoForOne && t.orderType == orderType);
        let totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);  
        if(totalQuantity % 2 == 1){
          const requestModal = await this.modalController.create({
            component: ItemTwoForOnesComponent,
            componentProps: {
              selectedCategory: this.twoForOneSelectedCategory,
              selectedItem: this.twoForOneSelectedItem
            }
          });
      
          requestModal.onWillDismiss()
            .then(async (result) => {
              if(result.data && result.data.item)
              {
                this.itemDetail(result.data.item)   
              }
              this.twoForOneSelectedItem = null;
              this.twoForOneSelectedCategory = null;
            });
          
          await requestModal.present();
        }
      }
    }
  }

